
// (function () {
//   const COMMISSION_STORE_KEY = "leeda_commission_store_v1";
//   const LEGACY_COMMISSION_CLEAR_KEY = "leeda_legacy_commission_fields_cleared_v1";

//   const debounce = (fn, wait = 400) => {
//     let t;
//     return (...args) => {
//       clearTimeout(t);
//       t = setTimeout(() => fn(...args), wait);
//     };
//   };

//   const safe = (v) => String(v ?? "").trim();

//   function toBool(v) {
//     if (v === true || v === 1) return true;
//     const text = safe(v).toLowerCase();
//     return text === "true" || text === "1" || text === "yes";
//   }

//   function hasOwn(obj, key) {
//     return !!(obj && Object.prototype.hasOwnProperty.call(obj, key));
//   }

//   function hasCollectFlag(dealer) {
//     return (
//       hasOwn(dealer, "isCollect") ||
//       hasOwn(dealer, "is_collect") ||
//       hasOwn(dealer, "collect") ||
//       hasOwn(dealer, "click_collect") ||
//       hasOwn(dealer, "clickAndCollect")
//     );
//   }

//   function isCollectDealer(dealer) {
//     if (!dealer) return false;

//     return (
//       toBool(dealer.isCollect) ||
//       toBool(dealer.is_collect) ||
//       toBool(dealer.collect) ||
//       toBool(dealer.click_collect) ||
//       toBool(dealer.clickAndCollect)
//     );
//   }

//   function getRoot(el) {
//     return el.closest("[data-collect-tabs]");
//   }

//   function belongsToRoot(root, node) {
//     if (!root || !node || !(root instanceof Element)) return true;
//     return node.closest("[data-collect-tabs]") === root;
//   }

//   function qs(root, sel) {
//     if (!root) return null;

//     const matches = Array.from(root.querySelectorAll(sel));
//     return matches.find((node) => belongsToRoot(root, node)) || null;
//   }

//   function qsa(root, sel) {
//     if (!root) return [];

//     const matches = Array.from(root.querySelectorAll(sel));
//     return matches.filter((node) => belongsToRoot(root, node));
//   }

//   function setHint(root, msg) {
//     const hint = qs(root, "[data-collect-hint]");
//     if (!hint) return;

//     if (!msg) {
//       hint.hidden = true;
//       hint.textContent = "";
//       return;
//     }

//     hint.hidden = false;
//     hint.textContent = msg;
//   }

//   function showUI(root, show) {
//     const ui = qs(root, "[data-collect-ui]");
//     if (!ui) return;
//     ui.hidden = !show;
//   }

//   function getSearchInput(root) {
//     return qs(root, "[data-collect-search]");
//   }

//   function setSearchMode(root, mode) {
//     if (!root) return;
//     root._collectSearchMode = mode;
//   }

//   function getSearchMode(root) {
//     return root && root._collectSearchMode ? root._collectSearchMode : "manual";
//   }

//   function markInputAsScriptSet(root, value) {
//     if (!root) return;
//     root._collectInputScriptSet = !!value;
//   }

//   function isInputScriptSet(root) {
//     return !!(root && root._collectInputScriptSet);
//   }

//   function markProgrammaticInputFocus(input, value) {
//     if (!input) return;
//     input.__collectProgrammaticFocus = !!value;
//   }

//   function isProgrammaticInputFocus(input) {
//     return !!(input && input.__collectProgrammaticFocus);
//   }

//   function forceInputFilledState(input) {
//     if (!input) return;

//     const wrapper =
//       input.closest(".input") ||
//       input.closest(".input-wrapper") ||
//       input.parentElement;

//     const label =
//       wrapper ? wrapper.querySelector(".input__label") : null;

//     const hasValue = safe(input.value).length > 0;

//     if (wrapper) {
//       wrapper.classList.toggle("has-value", hasValue);
//       wrapper.classList.toggle("is-filled", hasValue);
//       wrapper.classList.toggle("filled", hasValue);
//     }

//     input.classList.toggle("has-value", hasValue);
//     input.classList.toggle("is-filled", hasValue);
//     input.classList.toggle("filled", hasValue);

//     if (label) {
//       label.classList.toggle("has-value", hasValue);
//       label.classList.toggle("is-filled", hasValue);
//       label.classList.toggle("filled", hasValue);

//       if (hasValue) {
//         label.style.transform = "translateY(-0.9rem) scale(0.85)";
//         label.style.transformOrigin = "left center";
//         label.style.pointerEvents = "none";
//         label.style.background = "rgb(var(--section-background, 255, 255, 255))";
//         label.style.padding = "0 4px";
//         label.style.lineHeight = "1";
//         label.style.zIndex = "2";
//       } else {
//         label.style.transform = "";
//         label.style.transformOrigin = "";
//         label.style.pointerEvents = "";
//         label.style.background = "";
//         label.style.padding = "";
//         label.style.lineHeight = "";
//         label.style.zIndex = "";
//       }
//     }
//   }

//   function refreshInputUI(input) {
//     if (!input) return;

//     const proto = Object.getPrototypeOf(input);
//     const valueSetter =
//       Object.getOwnPropertyDescriptor(proto, "value")?.set ||
//       Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value")?.set;

//     const currentValue = input.value;

//     if (valueSetter) {
//       valueSetter.call(input, currentValue);
//     } else {
//       input.value = currentValue;
//     }

//     input.dispatchEvent(new Event("input", { bubbles: true }));
//     input.dispatchEvent(new Event("change", { bubbles: true }));

//     forceInputFilledState(input);

//     requestAnimationFrame(() => {
//       forceInputFilledState(input);

//       markProgrammaticInputFocus(input, true);
//       input.focus({ preventScroll: true });

//       requestAnimationFrame(() => {
//         forceInputFilledState(input);

//         setTimeout(() => {
//           input.blur();
//           markProgrammaticInputFocus(input, false);
//           forceInputFilledState(input);
//         }, 30);
//       });
//     });
//   }

//   function setInputValue(root, text, options = {}) {
//     const input = getSearchInput(root);
//     if (!input) return;

//     const value = safe(text);
//     input.value = value;
//     input.setAttribute("value", value);
//     root._collectLastSearchText = value;

//     markInputAsScriptSet(root, options.scriptSet !== false);

//     refreshInputUI(input);
//   }

//   function setInputCoords(root, lat, lng) {
//     const input = getSearchInput(root);
//     if (!input) return;

//     const latText = Number(lat).toFixed(4);
//     const lngText = Number(lng).toFixed(4);
//     const text = `${latText}, ${lngText}`;

//     input.value = text;
//     input.setAttribute("value", text);
//     root._collectLastSearchText = text;

//     markInputAsScriptSet(root, true);

//     refreshInputUI(input);
//   }

//   function clearInput(root, { clearHint = false, resetQuery = true, scriptSet = false } = {}) {
//     const input = getSearchInput(root);
//     if (!input) return;

//     input.value = "";
//     input.setAttribute("value", "");
//     root._collectLastSearchText = "";
//     markInputAsScriptSet(root, !!scriptSet);

//     if (resetQuery) {
//       lastQuery.delete(root);
//     }

//     if (clearHint) {
//       setHint(root, "");
//     }

//     refreshInputUI(input);
//   }

//   function readCommissionStore() {
//     try {
//       const raw = localStorage.getItem(COMMISSION_STORE_KEY);
//       if (!raw) return null;
//       const parsed = JSON.parse(raw);
//       const name = safe(parsed && parsed.name);
//       const code = safe(parsed && parsed.code);
//       if (!name || !code) return null;
//       return { name, code };
//     } catch (e) {
//       return null;
//     }
//   }

//   function clearLegacyCommissionAttributesOnce() {
//     try {
//       if (sessionStorage.getItem(LEGACY_COMMISSION_CLEAR_KEY) === "1") return;
//       sessionStorage.setItem(LEGACY_COMMISSION_CLEAR_KEY, "1");
//     } catch (e) {
//       // Continue without sessionStorage guard if unavailable.
//     }

//     fetch("/cart/update.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json",
//       },
//       body: JSON.stringify({
//         attributes: {
//           commission_store_name: "",
//           home_delivery_commission_store_name: "",
//           home_delivery_commission_store_code: "",
//         },
//       }),
//     }).catch(function () {
//       // Best effort cleanup only.
//     });
//   }

//   function writeCommissionStore(store) {
//     try {
//       if (!store || !safe(store.name) || !safe(store.code)) {
//         localStorage.removeItem(COMMISSION_STORE_KEY);
//       } else {
//         localStorage.setItem(COMMISSION_STORE_KEY, JSON.stringify({
//           name: safe(store.name),
//           code: safe(store.code),
//         }));
//       }
//     } catch (e) {
//       return;
//     }

//     window.dispatchEvent(new CustomEvent("map:commission-store-updated"));
//   }

//   function isCommissionContext(root) {
//     return safe(root && root.getAttribute("data-collect-context")).toLowerCase() === "commission";
//   }

//   function getHomeCommissionPicker(root) {
//     return qs(root, "[data-home-commission-picker]");
//   }

//   function setHomeCommissionPickerOpen(root, open) {
//     const picker = getHomeCommissionPicker(root);
//     if (!picker) return;
//     picker.dataset.commissionOpen = open ? "1" : "0";
//   }

//   function isHomeCommissionPickerOpen(root) {
//     const picker = getHomeCommissionPicker(root);
//     return !!(picker && picker.dataset && picker.dataset.commissionOpen === "1");
//   }

//   function openHomeCommissionPicker(root) {
//     if (!root || isCommissionContext(root)) return;
//     setHomeCommissionPickerOpen(root, true);
//     syncCommissionStoreUI(root);
//     syncCheckoutState(root);
//   }

//   function closeHomeCommissionPicker(root) {
//     if (!root || isCommissionContext(root)) return;
//     setHomeCommissionPickerOpen(root, false);
//     syncCommissionStoreUI(root);
//     syncCheckoutState(root);
//   }

//   function bindHomeCommissionPickerInteractions(root) {
//     if (!root || isCommissionContext(root)) return;

//     const picker = getHomeCommissionPicker(root);
//     if (!picker || picker.__commissionPickerBound) return;

//     picker.__commissionPickerBound = true;

//     picker.addEventListener("click", function (e) {
//       const target = e.target;
//       if (!(target instanceof Element)) return;

//       const closeTrigger = target.closest("[data-commission-panel-toggle]");
//       if (closeTrigger) {
//         e.preventDefault();
//         closeHomeCommissionPicker(root);
//         return;
//       }

//       const infoLink = target.closest(".commission-store__link");
//       if (infoLink && safe(infoLink.getAttribute("href")) === "#") {
//         e.preventDefault();
//       }

//       const openTrigger = target.closest(
//         "[data-commission-card-open], [data-commission-change], [data-commission-card-chosen]"
//       );
//       if (openTrigger) {
//         e.preventDefault();
//         openHomeCommissionPicker(root);
//       }
//     });

//     picker.addEventListener("keydown", function (e) {
//       const target = e.target;
//       if (!(target instanceof Element)) return;
//       if (e.key !== "Enter" && e.key !== " ") return;

//       const openTrigger = target.closest(
//         "[data-commission-card-open], [data-commission-card-chosen]"
//       );
//       if (!openTrigger) return;

//       e.preventDefault();
//       openHomeCommissionPicker(root);
//     });
//   }

//   function hasStoredCommissionCode() {
//     const store = readCommissionStore();
//     return !!(store && store.code);
//   }

//   function syncCommissionStoreUI(root) {
//     if (!root) return;

//     const store = readCommissionStore();
//     const isHomeActive = isHomeTabActive(root);
//     const isCollectActive = isClickAndCollectTabActive(root);

//     const note = qs(root, "[data-home-commission-store]");
//     const noteName = qs(root, "[data-home-commission-store-name]");

//     if (note && noteName) {
//       if (store && store.name) {
//         noteName.textContent = store.name;
//         note.hidden = false;
//       } else {
//         note.hidden = true;
//         noteName.textContent = "";
//       }
//     }

//     const picker = getHomeCommissionPicker(root);
//     if (picker) {
//       const chosenCard = picker.querySelector("[data-commission-card-chosen]");
//       const openCard = picker.querySelector("[data-commission-card-open]");
//       const panel = picker.querySelector("[data-commission-panel]");
//       const chosenName = picker.querySelector("[data-commission-chosen-name]");

//       const homeAllowed = isTabAllowed(root, "home");
//       const hasStoredStore = !!(store && store.name && store.code);
//       const panelOpen = isHomeCommissionPickerOpen(root);

//       if (chosenName) {
//         chosenName.textContent = hasStoredStore ? safe(store.name) : "";
//       }

//       if (!homeAllowed) {
//         picker.hidden = true;
//         if (chosenCard) chosenCard.hidden = true;
//         if (openCard) openCard.hidden = true;
//         if (panel) panel.hidden = true;
//       } else {
//         picker.hidden = false;

//         if (panelOpen) {
//           if (chosenCard) chosenCard.hidden = true;
//           if (openCard) openCard.hidden = true;
//           if (panel) panel.hidden = false;
//         } else if (hasStoredStore) {
//           if (chosenCard) chosenCard.hidden = false;
//           if (openCard) openCard.hidden = true;
//           if (panel) panel.hidden = true;
//         } else {
//           if (chosenCard) chosenCard.hidden = true;
//           if (openCard) openCard.hidden = false;
//           if (panel) panel.hidden = true;
//         }
//       }
//     }

//     const commissionCodeInput = qs(root, "[data-commission-store-code-input]");
//     const collectStoreCodeInput = qs(root, "[data-collect-hidden-store-id]");
//     const selectedCollectStoreCode = safe(collectStoreCodeInput && collectStoreCodeInput.value);

//     // Click & Collect: mirror the selected collect store into generic commission fields.
//     const shouldAttachCollectCommission =
//       isCollectActive &&
//       hasSelectedStore(root) &&
//       selectedCollectStoreCode;

//     // Home Delivery: keep current behaviour by using the selected commission store from localStorage.
//     const shouldAttachHomeCommission =
//       isHomeActive &&
//       store &&
//       store.code;

//     if (commissionCodeInput) {
//       // Click & Collect uses the selected collect store code.
//       if (shouldAttachCollectCommission) commissionCodeInput.value = selectedCollectStoreCode;
//       else if (shouldAttachHomeCommission) commissionCodeInput.value = store.code;
//       else commissionCodeInput.value = "";
//     }
//   }

//   // ---------------- CHECKOUT BUTTON CONTROL ----------------
//   function getCheckoutButton(root) {
//     const methodInput = qs(root, "[data-collect-hidden-method]");
//     const formId = methodInput ? safe(methodInput.getAttribute("form")) : "";

//     if (formId) {
//       const explicitFormButton =
//         document.querySelector(`[data-mini-cart-checkout][form="${formId}"]`) ||
//         document.querySelector(`button[name="checkout"][form="${formId}"]`);

//       if (explicitFormButton) return explicitFormButton;

//       const formEl = document.getElementById(formId);
//       if (formEl) {
//         const inFormButton =
//           formEl.querySelector("[data-mini-cart-checkout]") ||
//           formEl.querySelector('button[name="checkout"]');

//         if (inFormButton) return inFormButton;
//       }
//     }

//     const nearestForm = root && root.closest ? root.closest("form") : null;
//     if (nearestForm) {
//       const nearestFormButton =
//         nearestForm.querySelector("[data-mini-cart-checkout]") ||
//         nearestForm.querySelector('button[name="checkout"]');

//       if (nearestFormButton) return nearestFormButton;
//     }

//     return (
//       document.querySelector("[data-mini-cart-checkout]") ||
//       document.querySelector('button[name="checkout"]')
//     );
//   }

//   function setCheckoutDisabled(root, disabled) {
//     const btn = getCheckoutButton(root);
//     if (!btn) return;

//     btn.disabled = !!disabled;
//     btn.setAttribute("aria-disabled", disabled ? "true" : "false");

//     if (disabled) btn.classList.add("is-disabled-by-collect");
//     else btn.classList.remove("is-disabled-by-collect");
//   }

//   function getHomeTabRadio(root) {
//     return root.querySelector('input[type="radio"][id^="collect_tab_home_"]');
//   }

//   function getCollectTabRadio(root) {
//     return root.querySelector('input[type="radio"][id^="collect_tab_collect_"]');
//   }

//   function isTabAllowed(root, tabName) {
//     if (!root) return false;

//     if (tabName === "home") {
//       const attr = safe(root.getAttribute("data-home-allowed")).toLowerCase();
//       return attr !== "false";
//     }

//     if (tabName === "collect") {
//       const attr = safe(root.getAttribute("data-collect-allowed")).toLowerCase();
//       return attr !== "false";
//     }

//     return false;
//   }

//   function isHomeTabActive(root) {
//     const homeRadio = getHomeTabRadio(root);
//     return !!(homeRadio && homeRadio.checked);
//   }

//   function isClickAndCollectTabActive(root) {
//     const collectRadio = getCollectTabRadio(root);
//     return !!(collectRadio && collectRadio.checked);
//   }

//   function ensureAllowedActiveTab(root) {
//     const homeRadio = getHomeTabRadio(root);
//     const collectRadio = getCollectTabRadio(root);
//     if (!homeRadio || !collectRadio) return;

//     const homeAllowed = isTabAllowed(root, "home");
//     const collectAllowed = isTabAllowed(root, "collect");

//     if (isHomeTabActive(root) && !homeAllowed && collectAllowed && !collectRadio.disabled) {
//       collectRadio.checked = true;
//       homeRadio.checked = false;
//       return;
//     }

//     if (isClickAndCollectTabActive(root) && !collectAllowed && homeAllowed && !homeRadio.disabled) {
//       homeRadio.checked = true;
//       collectRadio.checked = false;
//       return;
//     }

//     if (!isHomeTabActive(root) && !isClickAndCollectTabActive(root)) {
//       if (homeAllowed && !homeRadio.disabled) {
//         homeRadio.checked = true;
//       } else if (collectAllowed && !collectRadio.disabled) {
//         collectRadio.checked = true;
//       }
//     }
//   }

//   function setCollectMethod(root, method) {
//     const methodInput = qs(root, "[data-collect-hidden-method]");
//     if (!methodInput) return;
//     methodInput.value = safe(method);
//   }

//   function setHiddenInput(input, value, enabled) {
//     if (!input) return;

//     input.value = enabled ? safe(value) : "";
//     input.disabled = !enabled;
//   }

//   function setOptionalHiddenValue(input, value, enabled) {
//     if (!input) return;

//     input.value = enabled ? safe(value) : "";
//   }

//   function setSelectedIndex(root, idx) {
//     if (!root) return;
//     if (idx == null || Number.isNaN(idx)) {
//       delete root.dataset.storeSelected;
//       delete root.dataset.storeSelectedIndex;
//       return;
//     }
//     root.dataset.storeSelected = "1";
//     root.dataset.storeSelectedIndex = String(idx);
//   }

//   function hasSelectedStore(root) {
//     return !!(root && root.dataset && root.dataset.storeSelected === "1");
//   }

//   function getSelectedIndex(root) {
//     const v = root && root.dataset ? root.dataset.storeSelectedIndex : null;
//     const n = Number(v);
//     return Number.isFinite(n) ? n : null;
//   }

//   function syncCheckoutState(root) {
//     if (!root) return;

//     if (isCommissionContext(root)) {
//       syncCommissionStoreUI(root);
//       return;
//     }

//     ensureAllowedActiveTab(root);
//     syncCommissionStoreUI(root);

//     const homeAllowed = isTabAllowed(root, "home");
//     const collectAllowed = isTabAllowed(root, "collect");

//     if (!homeAllowed && !collectAllowed) {
//       setCollectMethod(root, "");
//       syncClickCollectAttributes(root);
//       setCheckoutDisabled(root, true);
//       return;
//     }

//     if (isHomeTabActive(root)) {
//       if (!homeAllowed) {
//         setCollectMethod(root, "");
//         syncClickCollectAttributes(root);
//         setCheckoutDisabled(root, true);
//         return;
//       }

//       setCollectMethod(root, "home_delivery");
//       syncClickCollectAttributes(root);
//       const requiresHomeCommission =
//         safe(root.getAttribute("data-require-home-commission")).toLowerCase() === "true";
//       setCheckoutDisabled(root, requiresHomeCommission && !hasStoredCommissionCode());
//       return;
//     }

//     if (!collectAllowed) {
//       setCollectMethod(root, "");
//       syncClickCollectAttributes(root);
//       setCheckoutDisabled(root, true);
//       return;
//     }

//     setCollectMethod(root, "click_collect");
//     syncClickCollectAttributes(root);
//     setCheckoutDisabled(root, !hasSelectedStore(root));
//   }
//   // ---------------------------------------------------------

//   // ---------------- DISTANCE (user location -> store) ----------------
//   function setUserCoords(root, lat, lng) {
//     if (!root) return;
//     root._collectUserCoords = { lat: Number(lat), lng: Number(lng) };
//   }

//   function getUserCoords(root) {
//     const c = root && root._collectUserCoords;
//     if (!c) return null;
//     if (!Number.isFinite(c.lat) || !Number.isFinite(c.lng)) return null;
//     return c;
//   }

//   function haversineMiles(lat1, lon1, lat2, lon2) {
//     const toRad = (n) => (n * Math.PI) / 180;
//     const R = 3958.7613;
//     const dLat = toRad(lat2 - lat1);
//     const dLon = toRad(lon2 - lon1);
//     const a =
//       Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//       Math.cos(toRad(lat1)) *
//         Math.cos(toRad(lat2)) *
//         Math.sin(dLon / 2) *
//         Math.sin(dLon / 2);
//     const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//     return R * c;
//   }

//   function getDistanceMilesForDealer(root, d) {
//     const u = getUserCoords(root);
//     if (u && d && Number.isFinite(d.lat) && Number.isFinite(d.lng)) {
//       const miles = haversineMiles(u.lat, u.lng, d.lat, d.lng);
//       if (Number.isFinite(miles)) return miles;
//     }

//     if (d && d.distance != null && Number.isFinite(Number(d.distance))) {
//       return Number(d.distance);
//     }

//     return null;
//   }
//   // -------------------------------------------------------------------

//   // ---------------- GOOGLE MAPS JS (for geocoding typed postcodes) ----------------
//   function getGoogleKey(root) {
//     return safe(root && root.getAttribute("data-google-maps-key"));
//   }

//   function ensureGoogleMaps(root) {
//     if (window.google && window.google.maps && window.google.maps.Geocoder) {
//       return Promise.resolve();
//     }

//     if (window.__collectGoogleMapsPromise) return window.__collectGoogleMapsPromise;

//     const key = getGoogleKey(root);
//     if (!key) {
//       return Promise.reject(new Error("Missing Google Maps API key (data-google-maps-key)."));
//     }

//     window.__collectGoogleMapsPromise = new Promise((resolve, reject) => {
//       const existing = document.querySelector('script[data-collect-google-maps="1"]');
//       if (existing) return;

//       const cbName = "__collectGoogleMapsInit_" + Math.random().toString(36).slice(2);
//       window[cbName] = () => {
//         try { delete window[cbName]; } catch (_) {}
//         resolve();
//       };

//       const s = document.createElement("script");
//       s.async = true;
//       s.defer = true;
//       s.setAttribute("data-collect-google-maps", "1");
//       s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(
//         key
//       )}&callback=${encodeURIComponent(cbName)}`;

//       s.onerror = () => reject(new Error("Failed to load Google Maps JS API."));
//       document.head.appendChild(s);
//     });

//     return window.__collectGoogleMapsPromise;
//   }

//   async function geocodeWithGoogle(root, query, signal) {
//     const localAbortKey = { aborted: false };
//     if (signal) {
//       if (signal.aborted) throw new DOMException("Aborted", "AbortError");
//       signal.addEventListener("abort", () => { localAbortKey.aborted = true; }, { once: true });
//     }

//     await ensureGoogleMaps(root);

//     const q = safe(query);
//     if (!q) return null;

//     return new Promise((resolve, reject) => {
//       const geocoder = new google.maps.Geocoder();
//       geocoder.geocode({ address: q }, (results, status) => {
//         if (localAbortKey.aborted) {
//           reject(new DOMException("Aborted", "AbortError"));
//           return;
//         }

//         if (status !== "OK" || !results || !results[0] || !results[0].geometry) {
//           console.warn("[collect-tabs] Google geocode status:", status);
//           resolve(null);
//           return;
//         }

//         const loc = results[0].geometry.location;
//         const lat = typeof loc.lat === "function" ? loc.lat() : loc.lat;
//         const lng = typeof loc.lng === "function" ? loc.lng() : loc.lng;

//         resolve({
//           lat: Number(lat),
//           lng: Number(lng),
//           formatted: safe(results[0].formatted_address),
//         });
//       });
//     });
//   }
//   // ------------------------------------------------------------------------------

//   async function fetchDealers(root, apiBase, lat, lng, signal) {
//     let url = apiBase;

//     if (!/(?:\?|&)limit=/i.test(url)) {
//       url += "&limit=100";
//     }

//     if (Number.isFinite(Number(lat)) && Number.isFinite(Number(lng))) {
//       url += `&lat=${encodeURIComponent(lat)}&lng=${encodeURIComponent(lng)}`;
//     }
//     const res = await fetch(url, { method: "GET", signal });
//     if (!res.ok) throw new Error("Dealer API failed");

//     const data = await res.json();

//     const dealers = Array.isArray(data)
//       ? data
//       : Array.isArray(data.results)
//         ? data.results
//         : Array.isArray(data.dealers)
//           ? data.dealers
//           : Array.isArray(data.data)
//             ? data.data
//             : [];

//     const validDealers = dealers.filter(function (dealer) {
//       return dealer && safe(dealer.code || dealer.store_code || dealer.storeCode || dealer.store_id || dealer.storeId || dealer.id || "") && safe(dealer.store_name || dealer.name || dealer.dealer_name || dealer.title || "");
//     });

//     // PDP commission selector should show all stores (match store locator),
//     // while cart/mini-cart click & collect should only show collect-enabled stores.
//     if (isCommissionContext(root)) {
//       return validDealers;
//     }

//     const collectDealers = validDealers.filter(isCollectDealer);

//     if (collectDealers.length > 0) {
//       return collectDealers;
//     }

//     // Fallback for environments where collect flag is omitted.
//     const anyCollectFlagPresent = validDealers.some(hasCollectFlag);
//     return anyCollectFlagPresent ? [] : validDealers;
//   }

//   function getDealerOpeningHours(dealer) {
//     const openingHours = dealer && dealer.raw && dealer.raw.openingHours;
//     const weekly = openingHours && Array.isArray(openingHours.weekly) ? openingHours.weekly : [];
//     const bankHolidayValue = safe(
//       openingHours &&
//       openingHours.bankHolidays &&
//       openingHours.bankHolidays.defaultClosed
//     ).toLowerCase();

//     function isBankHolidayLabel(day) {
//       return safe(day).toLowerCase().replace(/[^a-z]/g, "") === "bankholiday" ||
//         safe(day).toLowerCase().replace(/[^a-z]/g, "") === "bankholidays";
//     }

//     const rows = weekly
//       .map(function (row) {
//         const day = safe(row.day);
//         const open = safe(row.open);
//         const close = safe(row.close);
//         const isBankHoliday = isBankHolidayLabel(day);

//         let value = "";
//         if (row.isClosed === true) {
//           value = "Closed";
//         } else if (open && close) {
//           value = open + " - " + close;
//         }

//         if (!day || !value) return null;

//         return {
//           day: day,
//           hours: value,
//           isBankHoliday: isBankHoliday,
//           hasWeekdayHours: !isBankHoliday && row.isClosed !== true && !!(open && close)
//         };
//       })
//       .filter(Boolean);

//     const hasWeekdayHours = rows.some(function (row) {
//       return row.hasWeekdayHours === true;
//     });

//     if (!hasWeekdayHours) {
//       return [];
//     }

//     if (rows.length > 0) {
//       if (bankHolidayValue === "closed") {
//         rows.push({
//           day: "Bank Holidays",
//           hours: "Closed",
//           isBankHoliday: true
//         });
//       } else if (bankHolidayValue === "open") {
//         rows.push({
//           day: "Bank Holidays",
//           hours: "Open",
//           isBankHoliday: true
//         });
//       }
//     }

//     return rows;
//   }

//   function renderOpeningHours(hoursArr) {
//     const hours = Array.isArray(hoursArr) ? hoursArr : [];

//     const rows = hours
//       .map((h) => {
//         const day = safe(h.day);
//         const open = safe(h.open);
//         const close = safe(h.close);
//         const val = open && close ? `${open} - ${close}` : safe(h.hours || "");

//         if (!day || !val) return "";

//         return `
//           <div class="collect-tabs__oh-row">
//             <div class="collect-tabs__oh-day">${day}</div>
//             <div class="collect-tabs__oh-time">${val}</div>
//           </div>
//         `;
//       })
//       .filter(Boolean)
//       .join("");

//     if (!rows) {
//       return "";
//     }

//     return `
//       <div class="collect-tabs__opening-hours">
//         <div class="collect-tabs__opening-hours-title">Opening Hours:</div>
//         <div class="collect-tabs__opening-hours-rows">${rows}</div>
//       </div>
//     `;
//   }

//   function normDealer(raw) {
//     const name = safe(raw.store_name || raw.name || raw.dealer_name || raw.title || "Store");
//     const storeCode = safe(
//       raw.code || raw.store_code || raw.storeCode || raw.store_id || raw.storeId || raw.id || ""
//     );

//     const email = safe(
//       (raw.contact && raw.contact.email) ||
//       raw.email ||
//       raw.store_email ||
//       raw.storeEmail ||
//       raw.contact_email ||
//       raw.contactEmail ||
//       ""
//     );

//     const phone = safe(
//       (raw.contact && raw.contact.phone) ||
//       raw.phone ||
//       ""
//     );

//     const website = safe(
//       (raw.contact && raw.contact.website) ||
//       raw.website ||
//       ""
//     );

//     const address = raw.address || {};
//     const address1 = safe(address.line1 || raw.address1 || raw.street || raw.line1 || raw.address_line1 || "");
//     const address2 = safe(address.line2 || raw.address2 || raw.line2 || raw.address_line2 || "");
//     const county = safe(address.county || raw.county || raw.region || raw.state || raw.address_line5 || "");
//     const town = safe(address.town || raw.city || raw.town || raw.locality || raw.address_line4 || "");
//     const city = safe(county || town);
//     const postcode = safe(address.postcode || raw.postcode || raw.zip || raw.postal_code || "");
//     const country = safe(address.country || raw.country || "");

//     const distance = raw.distance != null ? Number(raw.distance) : null;

//     const lat =
//       raw.location && raw.location.latitude != null
//         ? Number(raw.location.latitude)
//         : raw.lat != null
//           ? Number(raw.lat)
//           : raw.latitude != null
//             ? Number(raw.latitude)
//             : null;

//     const lng =
//       raw.location && raw.location.longitude != null
//         ? Number(raw.location.longitude)
//         : raw.lng != null
//           ? Number(raw.lng)
//           : raw.longitude != null
//             ? Number(raw.longitude)
//             : null;

//     const fullAddress = [address1, address2, town, county, postcode, country]
//       .filter(Boolean)
//       .join(", ");

//     const addressForUI = [address1, address2, town, county, postcode, country]
//       .filter(Boolean)
//       .join(", ");

//     return {
//       raw,
//       name,
//       storeCode,
//       email,
//       phone,
//       website,
//       address1,
//       address2,
//       fullAddress,
//       addressForUI,
//       city,
//       postcode,
//       country,
//       distance,
//       lat,
//       lng
//     };
//   }

//   function googleEmbedUrl(d) {
//     if (d && d.lat != null && d.lng != null && !Number.isNaN(d.lat) && !Number.isNaN(d.lng)) {
//       return `https://www.google.com/maps?q=${encodeURIComponent(d.lat + "," + d.lng)}&z=15&output=embed`;
//     }

//     const q = d.fullAddress || d.name;
//     return `https://www.google.com/maps?q=${encodeURIComponent(q)}&z=15&output=embed`;
//   }

//   function ensureMapConnectionHints() {
//     if (document.head && !document.querySelector('link[data-collect-preconnect="maps-google"]')) {
//       const link = document.createElement("link");
//       link.rel = "preconnect";
//       link.href = "https://www.google.com";
//       link.setAttribute("crossorigin", "");
//       link.setAttribute("data-collect-preconnect", "maps-google");
//       document.head.appendChild(link);
//     }

//     if (document.head && !document.querySelector('link[data-collect-dns-prefetch="maps-google"]')) {
//       const link = document.createElement("link");
//       link.rel = "dns-prefetch";
//       link.href = "//www.google.com";
//       link.setAttribute("data-collect-dns-prefetch", "maps-google");
//       document.head.appendChild(link);
//     }
//   }

//   const mapLoadTimers = new WeakMap();

//   function scheduleMapLoadForAccordion(acc, delayMs = 60) {
//     if (!acc) return;

//     const existingTimer = mapLoadTimers.get(acc);
//     if (existingTimer) {
//       clearTimeout(existingTimer);
//     }

//     const timer = setTimeout(() => {
//       mapLoadTimers.delete(acc);
//       if (!acc.open) return;
//       loadMapForAccordion(acc);
//     }, delayMs);

//     mapLoadTimers.set(acc, timer);
//   }

//   function loadMapForAccordion(acc) {
//     if (!acc) return;
//     const iframe = acc.querySelector("[data-collect-map]");
//     if (!iframe) return;

//     const targetSrc = safe(iframe.getAttribute("data-collect-map-src"));
//     if (!targetSrc) return;

//     const currentSrc = safe(iframe.getAttribute("src"));
//     if (currentSrc === targetSrc) return;

//     iframe.setAttribute("src", targetSrc);
//   }

//   function unloadMapForAccordion(acc) {
//     if (!acc) return;

//     const existingTimer = mapLoadTimers.get(acc);
//     if (existingTimer) {
//       clearTimeout(existingTimer);
//       mapLoadTimers.delete(acc);
//     }

//     const iframe = acc.querySelector("[data-collect-map]");
//     if (!iframe) return;

//     const currentSrc = safe(iframe.getAttribute("src"));
//     if (!currentSrc || currentSrc === "about:blank") return;

//     iframe.setAttribute("src", "about:blank");
//   }

//   function getSelectedDealer(root) {
//     if (!root) return null;

//     if (root._collectSelectedDealer) {
//       return root._collectSelectedDealer;
//     }

//     const idx = getSelectedIndex(root);
//     if (idx == null || !root._collectDealers) return null;

//     return root._collectDealers[idx] || null;
//   }

//   function syncClickCollectAttributes(root) {
//     if (!root) return;

//     const dealer = getSelectedDealer(root);
//     const enabled = !!(isClickAndCollectTabActive(root) && hasSelectedStore(root) && dealer);

//     setOptionalHiddenValue(qs(root, "[data-collect-hidden-store-name]"), dealer && dealer.name, enabled);
//     setOptionalHiddenValue(
//       qs(root, "[data-collect-hidden-store-address]"),
//       dealer && (dealer.fullAddress || dealer.addressForUI),
//       enabled
//     );
//     setOptionalHiddenValue(qs(root, "[data-collect-hidden-store-id]"), dealer && dealer.storeCode, enabled);
//     setOptionalHiddenValue(qs(root, "[data-collect-hidden-store-email]"), dealer && dealer.email, enabled);
//     setOptionalHiddenValue(qs(root, "[data-collect-hidden-store-phone]"), dealer && dealer.phone, enabled);
//     setHiddenInput(qs(root, "[data-collect-hidden-fulfilment-method]"), "Click and Collect", enabled);
//     setHiddenInput(qs(root, "[data-collect-hidden-collection-store-id]"), dealer && dealer.storeCode, enabled);
//     setHiddenInput(qs(root, "[data-collect-hidden-collection-store-name]"), dealer && dealer.name, enabled);
//   }

//   function getClickCollectAttributes(root) {
//     const dealer = getSelectedDealer(root);
//     if (!dealer || !isClickAndCollectTabActive(root) || !hasSelectedStore(root)) return null;

//     return {
//       collect_method: "click_collect",
//       collect_store_name: safe(dealer.name),
//       collect_store_address: safe(dealer.fullAddress || dealer.addressForUI),
//       collect_store_code: safe(dealer.storeCode),
//       collect_store_email: safe(dealer.email),
//       collect_store_phone: safe(dealer.phone),
//       commission_store_code: safe(dealer.storeCode),
//       fulfilment_method: "Click and Collect",
//       collection_store_id: safe(dealer.storeCode),
//       collection_store_name: safe(dealer.name),
//     };
//   }

//   function getHomeDeliveryAttributes() {
//       const store = readCommissionStore();
//       const commissionStoreCode = safe(store && store.code);
//     return {
//       collect_method: "home_delivery",
//       collect_store_name: "",
//       collect_store_address: "",
//       collect_store_code: "",
//       collect_store_email: "",
//       collect_store_phone: "",
//       commission_store_code: commissionStoreCode,
//       fulfilment_method: "",
//       collection_store_id: "",
//       collection_store_name: "",
//     };
//   }

//   function getCheckoutPath() {
//     const routes = window.themeVariables && window.themeVariables.routes;
//     const rootPrefix = safe(routes && routes.rootUrlWithoutSlash);
//     return `${rootPrefix}/checkout`;
//   }

//   function getCheckoutAddress1(dealer) {
//     const baseAddress = safe(dealer && (dealer.address1 || dealer.fullAddress || dealer.addressForUI));
//     return [baseAddress, safe(dealer && dealer.address2)]
//       .filter(Boolean)
//       .join(", ");
//   }

//   function buildCheckoutPrefillUrl(root) {
//     const dealer = getSelectedDealer(root);
//     const url = new URL(getCheckoutPath(), window.location.origin);

//     url.searchParams.set("step", "contact_information");
//     url.searchParams.set("checkout[shipping_address][first_name]", "");
//     url.searchParams.set("checkout[shipping_address][last_name]", "");
//     url.searchParams.set(
//       "checkout[shipping_address][company]",
//       safe(dealer && dealer.name) ? `${safe(dealer && dealer.name)}, Click & Collect` : "Click & Collect"
//     );
//     url.searchParams.set(
//       "checkout[shipping_address][address1]",
//       getCheckoutAddress1(dealer)
//     );
//     url.searchParams.set("checkout[shipping_address][address2]", "");
//     url.searchParams.set("checkout[shipping_address][city]", safe(dealer && dealer.city));
//     url.searchParams.set("checkout[shipping_address][zip]", safe(dealer && dealer.postcode));
//     url.searchParams.set(
//       "checkout[shipping_address][country]",
//       safe((dealer && dealer.country) || "United Kingdom")
//     );
//     url.searchParams.set("checkout[shipping_address][phone]", "");
//     return url.toString();
//   }

//   function buildCheckoutClearUrl() {
//     const url = new URL(getCheckoutPath(), window.location.origin);

//     url.searchParams.set("step", "contact_information");
//     setBlankCheckoutShippingParams(url);

//     return url.toString();
//   }

//   function setBlankCheckoutShippingParams(url) {
//     url.searchParams.set("checkout[shipping_address][first_name]", "");
//     url.searchParams.set("checkout[shipping_address][last_name]", "");
//     url.searchParams.set("checkout[shipping_address][company]", "");
//     url.searchParams.set("checkout[shipping_address][address1]", "");
//     url.searchParams.set("checkout[shipping_address][address2]", "");
//     url.searchParams.set("checkout[shipping_address][city]", "");
//     url.searchParams.set("checkout[shipping_address][zip]", "");
//     url.searchParams.set("checkout[shipping_address][phone]", "");
//   }

//   function buildCartPermalinkCheckoutUrl(cart) {
//     const items = cart && Array.isArray(cart.items) ? cart.items : [];
//     const itemPath = items
//       .filter(function (item) {
//         return item && item.variant_id && item.quantity > 0;
//       })
//       .map(function (item) {
//         return `${encodeURIComponent(item.variant_id)}:${encodeURIComponent(item.quantity)}`;
//       })
//       .join(",");

//     if (!itemPath) return buildCheckoutClearUrl();

//     const routes = window.themeVariables && window.themeVariables.routes;
//     const rootPrefix = safe(routes && routes.rootUrlWithoutSlash);
//     const url = new URL(`${rootPrefix}/cart/${itemPath}`, window.location.origin);

//     url.searchParams.set("step", "contact_information");
//     url.searchParams.set("attributes[collect_method]", "home_delivery");
//     url.searchParams.set("attributes[commission_store_code]", commissionStoreCode);

//     setBlankCheckoutShippingParams(url);

//     return url.toString();
//   }

//   function fetchCartForCheckout() {
//     const routes = window.themeVariables && window.themeVariables.routes;
//     const cartUrl = safe(routes && routes.cartUrl) || "/cart";

//     return fetch(`${cartUrl}.js`, {
//       headers: { Accept: "application/json" },
//       cache: "reload",
//     }).then(function (response) {
//       if (!response.ok) throw new Error("Could not load cart before checkout");
//       return response.json();
//     });
//   }

//   function submitClickCollectCheckout(root) {
//     const checkoutUrl = buildCheckoutPrefillUrl(root);
//     const attributes = getClickCollectAttributes(root);

//     if (!attributes || root.__collectCheckoutSubmitting) {
//       window.location.href = checkoutUrl;
//       return;
//     }

//     root.__collectCheckoutSubmitting = true;
//     setCheckoutDisabled(root, true);

//     fetch("/cart/update.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json",
//       },
//       body: JSON.stringify({ attributes }),
//     })
//       .catch(function (error) {
//         console.warn("[collect-tabs] Could not save Click & Collect attributes before checkout:", error);
//       })
//       .finally(function () {
//         window.location.href = checkoutUrl;
//       });
//   }

//   function submitHomeDeliveryCheckout(root) {
//     if (root.__homeDeliveryCheckoutSubmitting) {
//       fetchCartForCheckout()
//         .then(function (cart) {
//           window.location.href = buildCartPermalinkCheckoutUrl(cart);
//         })
//         .catch(function () {
//           window.location.href = buildCheckoutClearUrl();
//         });
//       return;
//     }

//     root.__homeDeliveryCheckoutSubmitting = true;
//     setCheckoutDisabled(root, true);

//     const clearAttributes = fetch("/cart/update.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json",
//       },
//       body: JSON.stringify({ attributes: getHomeDeliveryAttributes() }),
//     }).catch(function (error) {
//         console.warn("[collect-tabs] Could not clear Click & Collect attributes before checkout:", error);
//       });

//     clearAttributes
//       .then(fetchCartForCheckout)
//       .then(function (cart) {
//         window.location.href = buildCartPermalinkCheckoutUrl(cart);
//       })
//       .catch(function () {
//         window.location.href = buildCheckoutClearUrl();
//       });
//   }

//   function setHidden(root, d, selected) {
//     const method = qs(root, "[data-collect-hidden-method]");

//     root._collectSelectedDealer = selected ? d : null;

//     if (method) method.value = selected ? "click_collect" : "home_delivery";
//     syncClickCollectAttributes(root);
//   }

//   function syncSelectedRowLayout(root) {
//     qsa(root, "[data-collect-acc]").forEach((acc) => {
//       const left = acc.querySelector("summary .left");
//       const right = acc.querySelector("summary .right");
//       const dist = acc.querySelector("summary .dist");
//       if (!left || !right || !dist) return;

//       const isSelected = acc.classList.contains("is-selected");

//       if (isSelected) {
//         if (dist.parentElement !== left) left.appendChild(dist);
//       } else {
//         if (dist.parentElement !== right) right.prepend(dist);
//       }
//     });
//   }

//   function syncSelectedButtonPlacement(root) {
//     qsa(root, "[data-collect-acc]").forEach((acc) => {
//       const summary = acc.querySelector("summary");
//       const btn = acc.querySelector("[data-collect-select-btn]");
//       if (!summary || !btn) return;

//       if (btn.parentElement !== summary) {
//         summary.appendChild(btn);
//       }
//     });
//   }

//   function resetSelection(root) {
//     setSelectedIndex(root, null);
//     setHidden(root, { name: "", fullAddress: "", addressForUI: "", storeCode: "", email: "", phone: "" }, false);

//     qsa(root, "[data-collect-acc]").forEach((acc) => {
//       acc.classList.remove("is-selected");
//       if (acc.open) acc.open = false;
//       unloadMapForAccordion(acc);
//     });

//     qsa(root, "[data-collect-select-btn]").forEach((b) => {
//       b.textContent = "Select";
//       b.classList.remove("is-selected");
//     });

//     syncSelectedRowLayout(root);
//     syncSelectedButtonPlacement(root);
//     syncCheckoutState(root);
//   }

//   function markSelectedUI(root, idx) {
//     qsa(root, "[data-collect-acc]").forEach((acc) => acc.classList.remove("is-selected"));
//     qsa(root, "[data-collect-select-btn]").forEach((b) => {
//       b.textContent = "Select";
//       b.classList.remove("is-selected");
//     });

//     const acc = qs(root, `[data-collect-acc][data-collect-index="${idx}"]`);
//     if (acc) acc.classList.add("is-selected");

//     const btn = qs(root, `[data-collect-acc][data-collect-index="${idx}"] [data-collect-select-btn]`);
//     if (btn) {
//       btn.textContent = "Selected";
//       btn.classList.add("is-selected");
//     }

//     syncSelectedRowLayout(root);
//     syncSelectedButtonPlacement(root);
//   }

//   function renderList(root, dealers) {
//     const box = qs(root, "[data-collect-results]");
//     if (!box) return;

//     const limitAttrRaw = Number(root.getAttribute("data-collect-max-results"));
//     const limit = Number.isFinite(limitAttrRaw) ? limitAttrRaw : 10;

//     let ordered = dealers
//       .map(normDealer)
//       .sort(function (a, b) {
//         const aMiles = getDistanceMilesForDealer(root, a);
//         const bMiles = getDistanceMilesForDealer(root, b);

//         if (aMiles == null && bMiles == null) return 0;
//         if (aMiles == null) return 1;
//         if (bMiles == null) return -1;

//         return aMiles - bMiles;
//       });

//     if (limit > 0) {
//       ordered = ordered.slice(0, limit);
//     }

//     root._collectDealers = ordered;

//     box.innerHTML = ordered
//       .map((d, i) => {
//         const miles = getDistanceMilesForDealer(root, d);
//         const dist = miles != null ? `${miles.toFixed(1)} Miles` : "";
//         const mapUrl = googleEmbedUrl(d);
//         const openingHoursHtml = renderOpeningHours(getDealerOpeningHours(d));

//         return `
//           <details class="collect-tabs__acc" data-collect-acc data-collect-index="${i}">
//             <summary class="collect-tabs__row">
//               <div class="content">
//                 <div class="left">
//                   <span class="name">${d.name}</span>
//                 </div>
//                 <div class="right">
//                   <span class="dist">${dist}</span>
//                   <span class="commission-store__link collect-tabs__more-info">More info</span>
//                 </div>
//               </div>
//               <button type="button" class="collect-tabs__select-btn" data-collect-select-btn>
//                 Select
//               </button>
//             </summary>

//             <div class="collect-tabs__detail">
//               <div class="collect-tabs__map-wrap">
//                 <iframe
//                   data-collect-map
//                   data-collect-map-src="${mapUrl}"
//                   class="collect-tabs__map"
//                   loading="lazy"
//                   referrerpolicy="no-referrer-when-downgrade"
//                   src="about:blank"
//                   title="Map"
//                 ></iframe>
//               </div>

//               <div class="collect-tabs__detail-body">
//                 <div class="collect-tabs__detail-header"></div>

//                 <div class="collect-tabs__detail-meta text--xsmall">
//                   <div><strong>Address:</strong> ${safe(d.addressForUI)}</div>
//                   ${openingHoursHtml}
//                 </div>
//               </div>
//             </div>
//           </details>
//         `;
//       })
//       .join("");

//     showUI(root, true);

//     qsa(root, "[data-collect-acc][open]").forEach((acc) => {
//       scheduleMapLoadForAccordion(acc);
//     });

//     syncSelectedRowLayout(root);
//     syncSelectedButtonPlacement(root);

//     if (isCommissionContext(root)) {
//       setSelectedIndex(root, null);
//     }
//   }

//   const controllers = new WeakMap();
//   const lastQuery = new WeakMap();

//   function abortInFlight(root) {
//     const prev = controllers.get(root);
//     if (prev) prev.abort();
//   }

//   async function doSearchByCoords(root, lat, lng, { force = false } = {}) {
//     const apiBase = root.getAttribute("data-dealer-api");
//     if (!apiBase) return;

//     setSearchMode(root, "geo");
//     setUserCoords(root, lat, lng);
//     setInputCoords(root, lat, lng);

//     const key = `__geo__${lat},${lng}`;
//     const prevQ = lastQuery.get(root);
//     if (!force && prevQ === key) return;
//     lastQuery.set(root, key);

//     abortInFlight(root);
//     const controller = new AbortController();
//     controllers.set(root, controller);

//     setHint(root, "Searching nearby shops…");
//     showUI(root, false);
//     resetSelection(root);

//     try {
//       const dealersRaw = await fetchDealers(root, apiBase, lat, lng, controller.signal);
//       if (!dealersRaw.length) {
//         setHint(root, "No shops found within range.");
//         showUI(root, false);
//         syncCheckoutState(root);
//         return;
//       }

//       setHint(root, "");
//       renderList(root, dealersRaw);
//     } catch (e) {
//       if (e.name === "AbortError") return;
//       console.warn("[collect-tabs] dealers error:", e);
//       setHint(root, "Couldn’t load shops (check CORS / API availability).");
//       showUI(root, false);
//       syncCheckoutState(root);
//     }
//   }

//   async function doSearch(root, query, { force = false } = {}) {
//     const apiBase = root.getAttribute("data-dealer-api");
//     if (!apiBase) return;

//     const q = safe(query);

//     setSearchMode(root, "manual");
//     markInputAsScriptSet(root, false);

//     if (q.length < 3) {
//       setHint(root, "");
//       showUI(root, false);
//       resetSelection(root);
//       return;
//     }

//     const prevQ = lastQuery.get(root);
//     if (!force && prevQ === q) return;
//     lastQuery.set(root, q);

//     abortInFlight(root);
//     const controller = new AbortController();
//     controllers.set(root, controller);

//     setHint(root, "Searching nearby shops…");
//     showUI(root, false);
//     resetSelection(root);

//     try {
//       const geo = await geocodeWithGoogle(root, q, controller.signal);

//       if (!geo) {
//         setHint(root, "No location found. Try a fuller postcode/address.");
//         showUI(root, false);
//         syncCheckoutState(root);
//         return;
//       }

//       setUserCoords(root, geo.lat, geo.lng);

//       const dealersRaw = await fetchDealers(root, apiBase, geo.lat, geo.lng, controller.signal);
//       if (!dealersRaw.length) {
//         setHint(root, "No shops found within range.");
//         showUI(root, false);
//         syncCheckoutState(root);
//         return;
//       }

//       setHint(root, "");
//       renderList(root, dealersRaw);
//     } catch (e) {
//       if (e.name === "AbortError") return;
//       console.warn("[collect-tabs] search error:", e);
//       setHint(root, "No location found. Try a fuller postcode/address.");
//       showUI(root, false);
//       syncCheckoutState(root);
//     }
//   }

//   async function doGeoLocate(root) {
//     if (!navigator.geolocation) {
//       setHint(root, "Geolocation isn’t available on this device. Type your postcode instead.");
//       return;
//     }

//     abortInFlight(root);
//     setSearchMode(root, "geo");
//     resetSelection(root);
//     setHint(root, "Getting your location...");
//     setInputValue(root, "Getting location...", { scriptSet: true });

//     navigator.geolocation.getCurrentPosition(
//       (pos) => {
//         const lat = pos.coords.latitude;
//         const lng = pos.coords.longitude;

//         setInputCoords(root, lat, lng);
//         doSearchByCoords(root, lat, lng, { force: true });
//       },
//       (err) => {
//         console.warn("Geolocation error:", err);
//         setHint(root, "Could not access your location. Please allow it or type your postcode.");
//         clearInput(root, { clearHint: false, resetQuery: true });
//         showUI(root, false);
//       },
//       { enableHighAccuracy: false, timeout: 12000, maximumAge: 60000 }
//     );
//   }

//   const debouncedSearch = debounce((root, value) => doSearch(root, value, { force: false }), 450);

//   document.addEventListener("input", function (e) {
//     const input =
//       e.target && e.target.matches && e.target.matches("[data-collect-search]") ? e.target : null;
//     if (!input) return;

//     const root = getRoot(input);
//     if (!root) return;

//     // Ignore synthetic input events triggered by script-driven UI refreshes
//     // (for example after selecting a store).
//     if (!e.isTrusted && isInputScriptSet(root)) {
//       return;
//     }

//     setSearchMode(root, "manual");
//     markInputAsScriptSet(root, false);
//     root._collectLastSearchText = safe(input.value);

//     if (isClickAndCollectTabActive(root)) {
//       resetSelection(root);
//       setCheckoutDisabled(root, true);
//     }

//     debouncedSearch(root, input.value);
//   });

//   document.addEventListener("focusin", function (e) {
//     const input =
//       e.target && e.target.matches && e.target.matches("[data-collect-search]") ? e.target : null;
//     if (!input) return;

//     const root = getRoot(input);
//     if (!root) return;

//     if (isProgrammaticInputFocus(input)) {
//       return;
//     }

//     if (isInputScriptSet(root) && safe(input.value)) {
//       clearInput(root, { clearHint: true, resetQuery: true });
//     }
//   });

//   document.addEventListener("click", function (e) {
//     const commissionInfoLink =
//       e.target && e.target.closest ? e.target.closest(".commission-store__link") : null;
//     if (commissionInfoLink && safe(commissionInfoLink.getAttribute("href")) === "#") {
//       e.preventDefault();
//     }

//     const commissionOpenTrigger =
//       e.target && e.target.closest
//         ? e.target.closest("[data-commission-card-open], [data-commission-change], [data-commission-card-chosen]")
//         : null;

//     if (commissionOpenTrigger) {
//       const root = getRoot(commissionOpenTrigger);
//       if (root) {
//         e.preventDefault();
//         openHomeCommissionPicker(root);
//       }
//       return;
//     }

//     const commissionPicker = e.target && e.target.closest ? e.target.closest("[data-home-commission-picker]") : null;
//     if (commissionPicker) {
//       const root = getRoot(commissionPicker);
//       const clickedInsidePanel = e.target && e.target.closest ? e.target.closest("[data-commission-panel]") : null;
//       const clickedClose = e.target && e.target.closest ? e.target.closest("[data-commission-panel-toggle]") : null;
//       const clickedInfoLink = e.target && e.target.closest ? e.target.closest(".commission-store__link") : null;

//       if (root && !isCommissionContext(root) && !clickedInsidePanel && !clickedClose && !clickedInfoLink) {
//         e.preventDefault();
//         openHomeCommissionPicker(root);
//         return;
//       }
//     }

//     const commissionCloseTrigger =
//       e.target && e.target.closest ? e.target.closest("[data-commission-panel-toggle]") : null;

//     if (commissionCloseTrigger) {
//       const root = getRoot(commissionCloseTrigger);
//       if (root) {
//         e.preventDefault();
//         closeHomeCommissionPicker(root);
//       }
//       return;
//     }

//     const input =
//       e.target && e.target.matches && e.target.matches("[data-collect-search]") ? e.target : null;

//     if (input) {
//       const root = getRoot(input);
//       if (!root) return;

//       if (isInputScriptSet(root) && safe(input.value)) {
//         clearInput(root, { clearHint: true, resetQuery: true });
//       }
//       return;
//     }

//     const geoBtn = e.target && e.target.closest ? e.target.closest("[data-collect-geolocate]") : null;
//     if (geoBtn) {
//       const root = getRoot(geoBtn);
//       if (!root) return;
//       doGeoLocate(root);
//       return;
//     }

//     const summary =
//       e.target && e.target.closest ? e.target.closest("[data-collect-acc] > summary") : null;

//     if (summary) {
//       const acc = summary.parentElement;
//       const root = getRoot(acc);
//       if (!root) return;

//       requestAnimationFrame(() => {
//         root.querySelectorAll("[data-collect-acc]").forEach((other) => {
//           if (other === acc) return;
//           if (other.open) other.open = false;
//           unloadMapForAccordion(other);
//         });

//         if (acc.open) {
//           scheduleMapLoadForAccordion(acc);
//         } else {
//           unloadMapForAccordion(acc);
//         }
//       });
//     }

//     const selectBtn =
//       e.target && e.target.closest ? e.target.closest("[data-collect-select-btn]") : null;

//     if (selectBtn) {
//       const root = getRoot(selectBtn);
//       if (!root) return;

//       const acc = selectBtn.closest("[data-collect-acc]");
//       const idx = acc ? Number(acc.getAttribute("data-collect-index")) : NaN;
//       const d = root._collectDealers && Number.isFinite(idx) ? root._collectDealers[idx] : null;
//       if (!d) return;

//       const currentlySelectedIdx = getSelectedIndex(root);

//       if (selectBtn.classList.contains("is-selected") && currentlySelectedIdx === idx) {
//         resetSelection(root);
//         clearInput(root, { clearHint: true, resetQuery: true });
//         return;
//       }

//       setHidden(root, d, true);
//       setSelectedIndex(root, idx);
//       markSelectedUI(root, idx);
//       syncCheckoutState(root);

//       if (isCommissionContext(root)) {
//         const selectedStore = {
//           name: safe(d.name),
//           code: safe(d.storeCode),
//         };
//         writeCommissionStore(selectedStore);
//         root.dispatchEvent(new CustomEvent("map:commission-store-selected", {
//           bubbles: true,
//           detail: selectedStore,
//         }));

//         const parentCollectRoot = root.parentElement
//           ? root.parentElement.closest("[data-collect-tabs]")
//           : null;

//         if (parentCollectRoot && parentCollectRoot !== root && !isCommissionContext(parentCollectRoot)) {
//           closeHomeCommissionPicker(parentCollectRoot);
//         }
//       }

//       clearInput(root, { clearHint: true, resetQuery: true, scriptSet: true });
//       return;
//     }
//   });

//   document.addEventListener("change", function (e) {
//     const radio =
//       e.target && e.target.matches && e.target.matches('input[type="radio"][id^="collect_tab_"]')
//         ? e.target
//         : null;
//     if (!radio) return;

//     const root = getRoot(radio);
//     if (!root) return;

//     syncCheckoutState(root);
//   });

//   document.addEventListener("submit", function (e) {
//     const form = e.target instanceof HTMLFormElement ? e.target : null;
//     if (!form) return;
//     let handled = false;

//     qsa(document, "[data-collect-tabs]").forEach(function (root) {
//       if (handled) return;
//       if (isCommissionContext(root)) return;

//       const methodInput = qs(root, "[data-collect-hidden-method]");
//       if (!methodInput) return;

//       const explicitFormId = safe(methodInput.getAttribute("form"));
//       const belongsToForm =
//         (explicitFormId && form.id === explicitFormId) ||
//         methodInput.form === form ||
//         root.closest("form") === form;

//       if (belongsToForm) {
//         syncCheckoutState(root);
//         if (isClickAndCollectTabActive(root) && hasSelectedStore(root) && getSelectedDealer(root)) {
//           handled = true;
//           e.preventDefault();
//           submitClickCollectCheckout(root);
//         } else if (isHomeTabActive(root)) {
//           handled = true;
//           e.preventDefault();
//           submitHomeDeliveryCheckout(root);
//         }
//       }
//     });
//   }, true);

//   document.addEventListener("keydown", function (e) {
//     const card =
//       e.target &&
//       e.target.matches &&
//       (e.target.matches("[data-commission-card-open]") ||
//         e.target.matches("[data-commission-card-chosen]"))
//         ? e.target
//         : null;
//     if (!card) return;

//     if (e.key !== "Enter" && e.key !== " ") return;
//     e.preventDefault();

//     const root = getRoot(card);
//     if (!root) return;
//     openHomeCommissionPicker(root);
//   });

//   function hydrateRoot(root) {
//     if (!root) return;

//     if (!root.__collectTabsBootstrapped) {
//       setSearchMode(root, "manual");
//       markInputAsScriptSet(root, false);
//       root.__collectTabsBootstrapped = true;
//       ensureMapConnectionHints();
//     }

//     if (isCommissionContext(root) && root.dataset.collectAutoLoaded !== "1") {
//       const autoLoad = safe(root.getAttribute("data-collect-auto-load")).toLowerCase();
//       const apiBase = safe(root.getAttribute("data-dealer-api"));

//       if (autoLoad === "all" && apiBase) {
//         root.dataset.collectAutoLoaded = "1";
//         setHint(root, "Loading shops...");
//         showUI(root, false);

//         fetchDealers(root, apiBase, null, null)
//           .then((dealersRaw) => {
//             if (!Array.isArray(dealersRaw) || !dealersRaw.length) {
//               return fetchDealers(root, apiBase, 54.5, -2, null);
//             }

//             return dealersRaw;
//           })
//           .then((dealersRaw) => {
//             if (!Array.isArray(dealersRaw) || !dealersRaw.length) {
//               setHint(root, "No shops found.");
//               showUI(root, false);
//               return;
//             }

//             setHint(root, "");
//             renderList(root, dealersRaw);
//           })
//           .catch((error) => {
//             console.warn("[collect-tabs] initial dealer load error:", error);
//             setHint(root, "Couldn’t load shops (check CORS / API availability).");
//             showUI(root, false);
//           });
//       }
//     }

//     if (!isCommissionContext(root)) {
//       clearLegacyCommissionAttributesOnce();
//     }

//     bindHomeCommissionPickerInteractions(root);

//     syncCheckoutState(root);
//     syncSelectedRowLayout(root);
//     syncSelectedButtonPlacement(root);
//     syncCommissionStoreUI(root);
//   }

//   function hydrateAllRoots() {
//     qsa(document, "[data-collect-tabs]").forEach(hydrateRoot);
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", hydrateAllRoots);
//   } else {
//     hydrateAllRoots();
//   }

//   const domObserver = new MutationObserver((mutations) => {
//     let shouldHydrate = false;

//     for (const mutation of mutations) {
//       for (const node of mutation.addedNodes) {
//         if (!(node instanceof Element)) continue;
//         if (node.matches("[data-collect-tabs]") || node.querySelector("[data-collect-tabs]")) {
//           shouldHydrate = true;
//           break;
//         }
//       }
//       if (shouldHydrate) break;
//     }

//     if (shouldHydrate) hydrateAllRoots();
//   });

//   const observeTarget = document.documentElement || document.body;
//   if (observeTarget) {
//     domObserver.observe(observeTarget, { childList: true, subtree: true });
//   }

//   window.addEventListener("storage", function (event) {
//     if (event && event.key && event.key !== COMMISSION_STORE_KEY) return;
//     hydrateAllRoots();
//   });

//   window.addEventListener("map:commission-store-updated", function () {
//     hydrateAllRoots();
//   });
// })();


(function () {
const COMMISSION_STORE_KEY = "leeda_commission_store_v1";
const LEGACY_COMMISSION_CLEAR_KEY = "leeda_legacy_commission_fields_cleared_v1";
  const debounce = (fn, wait = 400) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  const safe = (v) => String(v ?? "").trim();

  function toBool(v) {
    if (v === true || v === 1) return true;
    const text = safe(v).toLowerCase();
    return text === "true" || text === "1" || text === "yes";
  }

  function hasOwn(obj, key) {
    return !!(obj && Object.prototype.hasOwnProperty.call(obj, key));
  }

  function hasCollectFlag(dealer) {
    return (
      hasOwn(dealer, "isCollect") ||
      hasOwn(dealer, "is_collect") ||
      hasOwn(dealer, "collect") ||
      hasOwn(dealer, "click_collect") ||
      hasOwn(dealer, "clickAndCollect")
    );
  }

  function isCollectDealer(dealer) {
    if (!dealer) return false;

    return (
      toBool(dealer.isCollect) ||
      toBool(dealer.is_collect) ||
      toBool(dealer.collect) ||
      toBool(dealer.click_collect) ||
      toBool(dealer.clickAndCollect)
    );
  }

  function getRoot(el) {
    return el.closest("[data-collect-tabs]");
  }

  function belongsToRoot(root, node) {
    if (!root || !node || !(root instanceof Element)) return true;
    return node.closest("[data-collect-tabs]") === root;
  }

  function qs(root, sel) {
    if (!root) return null;

    const matches = Array.from(root.querySelectorAll(sel));
    return matches.find((node) => belongsToRoot(root, node)) || null;
  }

  function qsa(root, sel) {
    if (!root) return [];

    const matches = Array.from(root.querySelectorAll(sel));
    return matches.filter((node) => belongsToRoot(root, node));
  }

  function setHint(root, msg) {
    const hint = qs(root, "[data-collect-hint]");
    if (!hint) return;

    if (!msg) {
      hint.hidden = true;
      hint.textContent = "";
      return;
    }

    hint.hidden = false;
    hint.textContent = msg;
  }

  function showUI(root, show) {
    const ui = qs(root, "[data-collect-ui]");
    if (!ui) return;
    ui.hidden = !show;
  }

  function getSearchInput(root) {
    return qs(root, "[data-collect-search]");
  }

  function setSearchMode(root, mode) {
    if (!root) return;
    root._collectSearchMode = mode;
  }

  function getSearchMode(root) {
    return root && root._collectSearchMode ? root._collectSearchMode : "manual";
  }

  function markInputAsScriptSet(root, value) {
    if (!root) return;
    root._collectInputScriptSet = !!value;
  }

  function isInputScriptSet(root) {
    return !!(root && root._collectInputScriptSet);
  }

  function markProgrammaticInputFocus(input, value) {
    if (!input) return;
    input.__collectProgrammaticFocus = !!value;
  }

  function isProgrammaticInputFocus(input) {
    return !!(input && input.__collectProgrammaticFocus);
  }

  function forceInputFilledState(input) {
    if (!input) return;

    const wrapper =
      input.closest(".input") ||
      input.closest(".input-wrapper") ||
      input.parentElement;

    const label =
      wrapper ? wrapper.querySelector(".input__label") : null;

    const hasValue = safe(input.value).length > 0;

    if (wrapper) {
      wrapper.classList.toggle("has-value", hasValue);
      wrapper.classList.toggle("is-filled", hasValue);
      wrapper.classList.toggle("filled", hasValue);
    }

    input.classList.toggle("has-value", hasValue);
    input.classList.toggle("is-filled", hasValue);
    input.classList.toggle("filled", hasValue);

    if (label) {
      label.classList.toggle("has-value", hasValue);
      label.classList.toggle("is-filled", hasValue);
      label.classList.toggle("filled", hasValue);

      if (hasValue) {
        label.style.transform = "translateY(-0.9rem) scale(0.85)";
        label.style.transformOrigin = "left center";
        label.style.pointerEvents = "none";
        label.style.background = "rgb(var(--section-background, 255, 255, 255))";
        label.style.padding = "0 4px";
        label.style.lineHeight = "1";
        label.style.zIndex = "2";
      } else {
        label.style.transform = "";
        label.style.transformOrigin = "";
        label.style.pointerEvents = "";
        label.style.background = "";
        label.style.padding = "";
        label.style.lineHeight = "";
        label.style.zIndex = "";
      }
    }
  }

  function refreshInputUI(input) {
    if (!input) return;

    const proto = Object.getPrototypeOf(input);
    const valueSetter =
      Object.getOwnPropertyDescriptor(proto, "value")?.set ||
      Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value")?.set;

    const currentValue = input.value;

    if (valueSetter) {
      valueSetter.call(input, currentValue);
    } else {
      input.value = currentValue;
    }

    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));

    forceInputFilledState(input);

    requestAnimationFrame(() => {
      forceInputFilledState(input);

      markProgrammaticInputFocus(input, true);
      input.focus({ preventScroll: true });

      requestAnimationFrame(() => {
        forceInputFilledState(input);

        setTimeout(() => {
          input.blur();
          markProgrammaticInputFocus(input, false);
          forceInputFilledState(input);
        }, 30);
      });
    });
  }

  function setInputValue(root, text, options = {}) {
    const input = getSearchInput(root);
    if (!input) return;

    const value = safe(text);
    input.value = value;
    input.setAttribute("value", value);
    root._collectLastSearchText = value;

    markInputAsScriptSet(root, options.scriptSet !== false);

    refreshInputUI(input);
  }

  function setInputCoords(root, lat, lng) {
    const input = getSearchInput(root);
    if (!input) return;

    const latText = Number(lat).toFixed(4);
    const lngText = Number(lng).toFixed(4);
    const text = `${latText}, ${lngText}`;

    input.value = text;
    input.setAttribute("value", text);
    root._collectLastSearchText = text;

    markInputAsScriptSet(root, true);

    refreshInputUI(input);
  }

  function clearInput(root, { clearHint = false, resetQuery = true, scriptSet = false } = {}) {
    const input = getSearchInput(root);
    if (!input) return;

    input.value = "";
    input.setAttribute("value", "");
    root._collectLastSearchText = "";
    markInputAsScriptSet(root, !!scriptSet);

    if (resetQuery) {
      lastQuery.delete(root);
    }

    if (clearHint) {
      setHint(root, "");
    }

    refreshInputUI(input);
  }

  function readCommissionStore() {
    try {
      const raw = localStorage.getItem(COMMISSION_STORE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      const name = safe(parsed && parsed.name);
      const code = safe(parsed && parsed.code);
      if (!name || !code) return null;
      return { name, code };
    } catch (e) {
      return null;
    }
  }

  function clearLegacyCommissionAttributesOnce() {
    try {
      if (sessionStorage.getItem(LEGACY_COMMISSION_CLEAR_KEY) === "1") return;
      sessionStorage.setItem(LEGACY_COMMISSION_CLEAR_KEY, "1");
    } catch (e) {
      // Continue without sessionStorage guard if unavailable.
    }

    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        attributes: {
          commission_store_name: "",
          home_delivery_commission_store_name: "",
          home_delivery_commission_store_code: "",
        },
      }),
    }).catch(function () {
      // Best effort cleanup only.
    });
  }

  function writeCommissionStore(store) {
    try {
      if (!store || !safe(store.name) || !safe(store.code)) {
        localStorage.removeItem(COMMISSION_STORE_KEY);
      } else {
        localStorage.setItem(COMMISSION_STORE_KEY, JSON.stringify({
          name: safe(store.name),
          code: safe(store.code),
        }));
      }
    } catch (e) {
      return;
    }

    window.dispatchEvent(new CustomEvent("map:commission-store-updated"));
  }

  function isCommissionContext(root) {
    return safe(root && root.getAttribute("data-collect-context")).toLowerCase() === "commission";
  }

  function getHomeCommissionPicker(root) {
    return qs(root, "[data-home-commission-picker]");
  }

  function setHomeCommissionPickerOpen(root, open) {
    const picker = getHomeCommissionPicker(root);
    if (!picker) return;
    picker.dataset.commissionOpen = open ? "1" : "0";
  }

  function isHomeCommissionPickerOpen(root) {
    const picker = getHomeCommissionPicker(root);
    return !!(picker && picker.dataset && picker.dataset.commissionOpen === "1");
  }

  function openHomeCommissionPicker(root) {
    if (!root || isCommissionContext(root)) return;
    setHomeCommissionPickerOpen(root, true);
    syncCommissionStoreUI(root);
    syncCheckoutState(root);
  }

  function closeHomeCommissionPicker(root) {
    if (!root || isCommissionContext(root)) return;
    setHomeCommissionPickerOpen(root, false);
    syncCommissionStoreUI(root);
    syncCheckoutState(root);
  }

  function bindHomeCommissionPickerInteractions(root) {
    if (!root || isCommissionContext(root)) return;

    const picker = getHomeCommissionPicker(root);
    if (!picker || picker.__commissionPickerBound) return;

    picker.__commissionPickerBound = true;

    picker.addEventListener("click", function (e) {
      const target = e.target;
      if (!(target instanceof Element)) return;

      const closeTrigger = target.closest("[data-commission-panel-toggle]");
      if (closeTrigger) {
        e.preventDefault();
        closeHomeCommissionPicker(root);
        return;
      }

      const infoLink = target.closest(".commission-store__link");
      if (infoLink && safe(infoLink.getAttribute("href")) === "#") {
        e.preventDefault();
      }

      const openTrigger = target.closest(
        "[data-commission-card-open], [data-commission-change], [data-commission-card-chosen]"
      );
      if (openTrigger) {
        e.preventDefault();
        openHomeCommissionPicker(root);
      }
    });

    picker.addEventListener("keydown", function (e) {
      const target = e.target;
      if (!(target instanceof Element)) return;
      if (e.key !== "Enter" && e.key !== " ") return;

      const openTrigger = target.closest(
        "[data-commission-card-open], [data-commission-card-chosen]"
      );
      if (!openTrigger) return;

      e.preventDefault();
      openHomeCommissionPicker(root);
    });
  }

  function hasStoredCommissionCode() {
    const store = readCommissionStore();
    return !!(store && store.code);
  }

  function syncCommissionStoreUI(root) {
    if (!root) return;

    const store = readCommissionStore();
    const isHomeActive = isHomeTabActive(root);
    const isCollectActive = isClickAndCollectTabActive(root);

    const note = qs(root, "[data-home-commission-store]");
    const noteName = qs(root, "[data-home-commission-store-name]");

    if (note && noteName) {
      if (store && store.name) {
        noteName.textContent = store.name;
        note.hidden = false;
      } else {
        note.hidden = true;
        noteName.textContent = "";
      }
    }

    const picker = getHomeCommissionPicker(root);
    if (picker) {
      const chosenCard = picker.querySelector("[data-commission-card-chosen]");
      const openCard = picker.querySelector("[data-commission-card-open]");
      const panel = picker.querySelector("[data-commission-panel]");
      const chosenName = picker.querySelector("[data-commission-chosen-name]");

      const homeAllowed = isTabAllowed(root, "home");
      const hasStoredStore = !!(store && store.name && store.code);
      const panelOpen = isHomeCommissionPickerOpen(root);

      if (chosenName) {
        chosenName.textContent = hasStoredStore ? safe(store.name) : "";
      }

      if (!homeAllowed) {
        picker.hidden = true;
        if (chosenCard) chosenCard.hidden = true;
        if (openCard) openCard.hidden = true;
        if (panel) panel.hidden = true;
      } else {
        picker.hidden = false;

        if (panelOpen) {
          if (chosenCard) chosenCard.hidden = true;
          if (openCard) openCard.hidden = true;
          if (panel) panel.hidden = false;
        } else if (hasStoredStore) {
          if (chosenCard) chosenCard.hidden = false;
          if (openCard) openCard.hidden = true;
          if (panel) panel.hidden = true;
        } else {
          if (chosenCard) chosenCard.hidden = true;
          if (openCard) openCard.hidden = false;
          if (panel) panel.hidden = true;
        }
      }
    }

    const commissionCodeInput = qs(root, "[data-commission-store-code-input]");
    const collectStoreCodeInput = qs(root, "[data-collect-hidden-store-id]");
    const selectedCollectStoreCode = safe(collectStoreCodeInput && collectStoreCodeInput.value);

    // Click & Collect: mirror the selected collect store into generic commission fields.
    const shouldAttachCollectCommission =
      isCollectActive &&
      hasSelectedStore(root) &&
      selectedCollectStoreCode;

    // Home Delivery: keep current behaviour by using the selected commission store from localStorage.
    const shouldAttachHomeCommission =
      isHomeActive &&
      store &&
      store.code;

    if (commissionCodeInput) {
      // Click & Collect uses the selected collect store code.
      if (shouldAttachCollectCommission) commissionCodeInput.value = selectedCollectStoreCode;
      else if (shouldAttachHomeCommission) commissionCodeInput.value = store.code;
      else commissionCodeInput.value = "";
    }
  }

  // ---------------- CHECKOUT BUTTON CONTROL ----------------
  function getCheckoutButton(root) {
    const methodInput = qs(root, "[data-collect-hidden-method]");
    const formId = methodInput ? safe(methodInput.getAttribute("form")) : "";

    if (formId) {
      const explicitFormButton =
        document.querySelector(`[data-mini-cart-checkout][form="${formId}"]`) ||
        document.querySelector(`button[name="checkout"][form="${formId}"]`);

      if (explicitFormButton) return explicitFormButton;

      const formEl = document.getElementById(formId);
      if (formEl) {
        const inFormButton =
          formEl.querySelector("[data-mini-cart-checkout]") ||
          formEl.querySelector('button[name="checkout"]');

        if (inFormButton) return inFormButton;
      }
    }

    const nearestForm = root && root.closest ? root.closest("form") : null;
    if (nearestForm) {
      const nearestFormButton =
        nearestForm.querySelector("[data-mini-cart-checkout]") ||
        nearestForm.querySelector('button[name="checkout"]');

      if (nearestFormButton) return nearestFormButton;
    }

    return (
      document.querySelector("[data-mini-cart-checkout]") ||
      document.querySelector('button[name="checkout"]')
    );
  }

function setCheckoutDisabled(root, disabled) {
  const btn = getCheckoutButton(root);
  if (!btn) return;

  btn.disabled = !!disabled;
  btn.setAttribute("aria-disabled", disabled ? "true" : "false");

  if (disabled) {
    btn.classList.add("is-disabled-by-collect");
    addDisabledCheckoutOverlay(root, btn);
  } else {
    btn.classList.remove("is-disabled-by-collect");
    removeDisabledCheckoutOverlay(btn);
  }
}

function showCheckoutWarning(root) {
  const homeWarning = qs(root, "[data-home-commission-warning]");
  const collectWarning = qs(root, "[data-click-collect-warning]");

  if (isHomeTabActive(root) && homeWarning) {
    homeWarning.hidden = false;
    homeWarning.scrollIntoView({
      behavior: "smooth",
      block: "nearest"
    });
  }

  if (isClickAndCollectTabActive(root) && collectWarning) {
    collectWarning.hidden = false;
    collectWarning.scrollIntoView({
      behavior: "smooth",
      block: "nearest"
    });
  }
}

function hideCheckoutWarnings(root) {
  const homeWarning = qs(root, "[data-home-commission-warning]");
  const collectWarning = qs(root, "[data-click-collect-warning]");

  if (homeWarning) homeWarning.hidden = true;
  if (collectWarning) collectWarning.hidden = true;
}



function addDisabledCheckoutOverlay(root, btn) {
  if (!btn || btn.__collectDisabledOverlay) return;

  const wrapper = document.createElement("span");
  wrapper.className = "collect-tabs__disabled-checkout-wrap";

  btn.parentNode.insertBefore(wrapper, btn);
  wrapper.appendChild(btn);

  const overlay = document.createElement("button");
  overlay.type = "button";
  overlay.className = "collect-tabs__disabled-checkout-overlay";
  overlay.setAttribute("aria-label", "Checkout disabled");

  overlay.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    showCheckoutWarning(root);
  });

  wrapper.appendChild(overlay);
  btn.__collectDisabledOverlay = overlay;
}

function removeDisabledCheckoutOverlay(btn) {
  if (!btn || !btn.__collectDisabledOverlay) return;

  const wrapper = btn.closest(".collect-tabs__disabled-checkout-wrap");
  const parent = wrapper && wrapper.parentNode;

  btn.__collectDisabledOverlay.remove();
  btn.__collectDisabledOverlay = null;

  if (wrapper && parent) {
    parent.insertBefore(btn, wrapper);
    wrapper.remove();
  }
}

  function getHomeTabRadio(root) {
    return root.querySelector('input[type="radio"][id^="collect_tab_home_"]');
  }

  function getCollectTabRadio(root) {
    return root.querySelector('input[type="radio"][id^="collect_tab_collect_"]');
  }

  function isTabAllowed(root, tabName) {
    if (!root) return false;

    if (tabName === "home") {
      const attr = safe(root.getAttribute("data-home-allowed")).toLowerCase();
      return attr !== "false";
    }

    if (tabName === "collect") {
      const attr = safe(root.getAttribute("data-collect-allowed")).toLowerCase();
      return attr !== "false";
    }

    return false;
  }

  function isHomeTabActive(root) {
    const homeRadio = getHomeTabRadio(root);
    return !!(homeRadio && homeRadio.checked);
  }

  function isClickAndCollectTabActive(root) {
    const collectRadio = getCollectTabRadio(root);
    return !!(collectRadio && collectRadio.checked);
  }

  function ensureAllowedActiveTab(root) {
    const homeRadio = getHomeTabRadio(root);
    const collectRadio = getCollectTabRadio(root);
    if (!homeRadio || !collectRadio) return;

    const homeAllowed = isTabAllowed(root, "home");
    const collectAllowed = isTabAllowed(root, "collect");

    if (isHomeTabActive(root) && !homeAllowed && collectAllowed && !collectRadio.disabled) {
      collectRadio.checked = true;
      homeRadio.checked = false;
      return;
    }

    if (isClickAndCollectTabActive(root) && !collectAllowed && homeAllowed && !homeRadio.disabled) {
      homeRadio.checked = true;
      collectRadio.checked = false;
      return;
    }

    if (!isHomeTabActive(root) && !isClickAndCollectTabActive(root)) {
      if (homeAllowed && !homeRadio.disabled) {
        homeRadio.checked = true;
      } else if (collectAllowed && !collectRadio.disabled) {
        collectRadio.checked = true;
      }
    }
  }

  function setCollectMethod(root, method) {
    const methodInput = qs(root, "[data-collect-hidden-method]");
    if (!methodInput) return;
    methodInput.value = safe(method);
  }

  function setHiddenInput(input, value, enabled) {
    if (!input) return;

    input.value = enabled ? safe(value) : "";
    input.disabled = !enabled;
  }

  function setOptionalHiddenValue(input, value, enabled) {
    if (!input) return;

    input.value = enabled ? safe(value) : "";
  }

  function setSelectedIndex(root, idx) {
    if (!root) return;
    if (idx == null || Number.isNaN(idx)) {
      delete root.dataset.storeSelected;
      delete root.dataset.storeSelectedIndex;
      return;
    }
    root.dataset.storeSelected = "1";
    root.dataset.storeSelectedIndex = String(idx);
  }

  function hasSelectedStore(root) {
    return !!(root && root.dataset && root.dataset.storeSelected === "1");
  }

  function getSelectedIndex(root) {
    const v = root && root.dataset ? root.dataset.storeSelectedIndex : null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  }

  function syncCheckoutState(root) {
    if (!root) return;

    if (isCommissionContext(root)) {
      syncCommissionStoreUI(root);
      return;
    }

    ensureAllowedActiveTab(root);
        const homeWarning = qs(root, "[data-home-commission-warning]");
        const collectWarning = qs(root, "[data-click-collect-warning]");

        if (homeWarning && hasStoredCommissionCode()) {
          homeWarning.hidden = true;
        }

        if (collectWarning && hasSelectedStore(root)) {
          collectWarning.hidden = true;
        }

    syncCommissionStoreUI(root);


    const homeAllowed = isTabAllowed(root, "home");
    const collectAllowed = isTabAllowed(root, "collect");

    if (!homeAllowed && !collectAllowed) {
      setCollectMethod(root, "");
      syncClickCollectAttributes(root);
      setCheckoutDisabled(root, true);
      return;
    }

    if (isHomeTabActive(root)) {
      if (!homeAllowed) {
        setCollectMethod(root, "");
        syncClickCollectAttributes(root);
        setCheckoutDisabled(root, true);
        return;
      }

      setCollectMethod(root, "home_delivery");
      syncClickCollectAttributes(root);
      const requiresHomeCommission =
        safe(root.getAttribute("data-require-home-commission")).toLowerCase() === "true";
      setCheckoutDisabled(root, requiresHomeCommission && !hasStoredCommissionCode());
      return;
    }

    if (!collectAllowed) {
      setCollectMethod(root, "");
      syncClickCollectAttributes(root);
      setCheckoutDisabled(root, true);
      return;
    }

    setCollectMethod(root, "click_collect");
    syncClickCollectAttributes(root);
    setCheckoutDisabled(root, !hasSelectedStore(root));
  }
  // ---------------------------------------------------------

  // ---------------- DISTANCE (user location -> store) ----------------
  function setUserCoords(root, lat, lng) {
    if (!root) return;
    root._collectUserCoords = { lat: Number(lat), lng: Number(lng) };
  }

  function getUserCoords(root) {
    const c = root && root._collectUserCoords;
    if (!c) return null;
    if (!Number.isFinite(c.lat) || !Number.isFinite(c.lng)) return null;
    return c;
  }

  function haversineMiles(lat1, lon1, lat2, lon2) {
    const toRad = (n) => (n * Math.PI) / 180;
    const R = 3958.7613;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  function getDistanceMilesForDealer(root, d) {
    const u = getUserCoords(root);
    if (u && d && Number.isFinite(d.lat) && Number.isFinite(d.lng)) {
      const miles = haversineMiles(u.lat, u.lng, d.lat, d.lng);
      if (Number.isFinite(miles)) return miles;
    }

    if (d && d.distance != null && Number.isFinite(Number(d.distance))) {
      return Number(d.distance);
    }

    return null;
  }
  // -------------------------------------------------------------------

  // ---------------- GOOGLE MAPS JS (for geocoding typed postcodes) ----------------
  function getGoogleKey(root) {
    return safe(root && root.getAttribute("data-google-maps-key"));
  }

  function ensureGoogleMaps(root) {
    if (window.google && window.google.maps && window.google.maps.Geocoder) {
      return Promise.resolve();
    }

    if (window.__collectGoogleMapsPromise) return window.__collectGoogleMapsPromise;

    const key = getGoogleKey(root);
    if (!key) {
      return Promise.reject(new Error("Missing Google Maps API key (data-google-maps-key)."));
    }

    window.__collectGoogleMapsPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-collect-google-maps="1"]');
      if (existing) return;

      const cbName = "__collectGoogleMapsInit_" + Math.random().toString(36).slice(2);
      window[cbName] = () => {
        try { delete window[cbName]; } catch (_) {}
        resolve();
      };

      const s = document.createElement("script");
      s.async = true;
      s.defer = true;
      s.setAttribute("data-collect-google-maps", "1");
      s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(
        key
      )}&callback=${encodeURIComponent(cbName)}`;

      s.onerror = () => reject(new Error("Failed to load Google Maps JS API."));
      document.head.appendChild(s);
    });

    return window.__collectGoogleMapsPromise;
  }

  async function geocodeWithGoogle(root, query, signal) {
    const localAbortKey = { aborted: false };
    if (signal) {
      if (signal.aborted) throw new DOMException("Aborted", "AbortError");
      signal.addEventListener("abort", () => { localAbortKey.aborted = true; }, { once: true });
    }

    await ensureGoogleMaps(root);

    const q = safe(query);
    if (!q) return null;

    return new Promise((resolve, reject) => {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: q }, (results, status) => {
        if (localAbortKey.aborted) {
          reject(new DOMException("Aborted", "AbortError"));
          return;
        }

        if (status !== "OK" || !results || !results[0] || !results[0].geometry) {
          console.warn("[collect-tabs] Google geocode status:", status);
          resolve(null);
          return;
        }

        const loc = results[0].geometry.location;
        const lat = typeof loc.lat === "function" ? loc.lat() : loc.lat;
        const lng = typeof loc.lng === "function" ? loc.lng() : loc.lng;

        resolve({
          lat: Number(lat),
          lng: Number(lng),
          formatted: safe(results[0].formatted_address),
        });
      });
    });
  }
  // ------------------------------------------------------------------------------

  async function fetchDealers(root, apiBase, lat, lng, signal) {
    let url = apiBase;

    if (!/(?:\?|&)limit=/i.test(url)) {
      url += "&limit=100";
    }

    if (Number.isFinite(Number(lat)) && Number.isFinite(Number(lng))) {
      url += `&lat=${encodeURIComponent(lat)}&lng=${encodeURIComponent(lng)}`;
    }
    const res = await fetch(url, { method: "GET", signal });
    if (!res.ok) throw new Error("Dealer API failed");

    const data = await res.json();

    const dealers = Array.isArray(data)
      ? data
      : Array.isArray(data.results)
        ? data.results
        : Array.isArray(data.dealers)
          ? data.dealers
          : Array.isArray(data.data)
            ? data.data
            : [];

    const validDealers = dealers.filter(function (dealer) {
      return dealer && safe(dealer.code || dealer.store_code || dealer.storeCode || dealer.store_id || dealer.storeId || dealer.id || "") && safe(dealer.store_name || dealer.name || dealer.dealer_name || dealer.title || "");
    });

    // PDP commission selector should show all stores (match store locator),
    // while cart/mini-cart click & collect should only show collect-enabled stores.
    if (isCommissionContext(root)) {
      return validDealers;
    }

    const collectDealers = validDealers.filter(isCollectDealer);

    if (collectDealers.length > 0) {
      return collectDealers;
    }

    // Fallback for environments where collect flag is omitted.
    const anyCollectFlagPresent = validDealers.some(hasCollectFlag);
    return anyCollectFlagPresent ? [] : validDealers;
  }

  function getDealerOpeningHours(dealer) {
    const openingHours = dealer && dealer.raw && dealer.raw.openingHours;
    const weekly = openingHours && Array.isArray(openingHours.weekly) ? openingHours.weekly : [];
    const bankHolidayValue = safe(
      openingHours &&
      openingHours.bankHolidays &&
      openingHours.bankHolidays.defaultClosed
    ).toLowerCase();

    function isBankHolidayLabel(day) {
      return safe(day).toLowerCase().replace(/[^a-z]/g, "") === "bankholiday" ||
        safe(day).toLowerCase().replace(/[^a-z]/g, "") === "bankholidays";
    }

    const rows = weekly
      .map(function (row) {
        const day = safe(row.day);
        const open = safe(row.open);
        const close = safe(row.close);
        const isBankHoliday = isBankHolidayLabel(day);

        let value = "";
        if (row.isClosed === true) {
          value = "Closed";
        } else if (open && close) {
          value = open + " - " + close;
        }

        if (!day || !value) return null;

        return {
          day: day,
          hours: value,
          isBankHoliday: isBankHoliday,
          hasWeekdayHours: !isBankHoliday && row.isClosed !== true && !!(open && close)
        };
      })
      .filter(Boolean);

    const hasWeekdayHours = rows.some(function (row) {
      return row.hasWeekdayHours === true;
    });

    if (!hasWeekdayHours) {
      return [];
    }

    if (rows.length > 0) {
      if (bankHolidayValue === "closed") {
        rows.push({
          day: "Bank Holidays",
          hours: "Closed",
          isBankHoliday: true
        });
      } else if (bankHolidayValue === "open") {
        rows.push({
          day: "Bank Holidays",
          hours: "Open",
          isBankHoliday: true
        });
      }
    }

    return rows;
  }

  function renderOpeningHours(hoursArr) {
    const hours = Array.isArray(hoursArr) ? hoursArr : [];

    const rows = hours
      .map((h) => {
        const day = safe(h.day);
        const open = safe(h.open);
        const close = safe(h.close);
        const val = open && close ? `${open} - ${close}` : safe(h.hours || "");

        if (!day || !val) return "";

        return `
          <div class="collect-tabs__oh-row">
            <div class="collect-tabs__oh-day">${day}</div>
            <div class="collect-tabs__oh-time">${val}</div>
          </div>
        `;
      })
      .filter(Boolean)
      .join("");

    if (!rows) {
      return "";
    }

    return `
      <div class="collect-tabs__opening-hours">
        <div class="collect-tabs__opening-hours-title">Opening Hours:</div>
        <div class="collect-tabs__opening-hours-rows">${rows}</div>
      </div>
    `;
  }

  function normDealer(raw) {
    const name = safe(raw.store_name || raw.name || raw.dealer_name || raw.title || "Store");
    const storeCode = safe(
      raw.code || raw.store_code || raw.storeCode || raw.store_id || raw.storeId || raw.id || ""
    );

    const email = safe(
      (raw.contact && raw.contact.email) ||
      raw.email ||
      raw.store_email ||
      raw.storeEmail ||
      raw.contact_email ||
      raw.contactEmail ||
      ""
    );

    const phone = safe(
      (raw.contact && raw.contact.phone) ||
      raw.phone ||
      ""
    );

    const website = safe(
      (raw.contact && raw.contact.website) ||
      raw.website ||
      ""
    );

    const address = raw.address || {};
    const address1 = safe(address.line1 || raw.address1 || raw.street || raw.line1 || raw.address_line1 || "");
    const address2 = safe(address.line2 || raw.address2 || raw.line2 || raw.address_line2 || "");
    const county = safe(address.county || raw.county || raw.region || raw.state || raw.address_line5 || "");
    const town = safe(address.town || raw.city || raw.town || raw.locality || raw.address_line4 || "");
    const city = safe(county || town);
    const postcode = safe(address.postcode || raw.postcode || raw.zip || raw.postal_code || "");
    const country = safe(address.country || raw.country || "");

    const distance = raw.distance != null ? Number(raw.distance) : null;

    const lat =
      raw.location && raw.location.latitude != null
        ? Number(raw.location.latitude)
        : raw.lat != null
          ? Number(raw.lat)
          : raw.latitude != null
            ? Number(raw.latitude)
            : null;

    const lng =
      raw.location && raw.location.longitude != null
        ? Number(raw.location.longitude)
        : raw.lng != null
          ? Number(raw.lng)
          : raw.longitude != null
            ? Number(raw.longitude)
            : null;

    const fullAddress = [address1, address2, town, county, postcode, country]
      .filter(Boolean)
      .join(", ");

    const addressForUI = [address1, address2, town, county, postcode, country]
      .filter(Boolean)
      .join(", ");

    return {
      raw,
      name,
      storeCode,
      email,
      phone,
      website,
      address1,
      address2,
      fullAddress,
      addressForUI,
      city,
      postcode,
      country,
      distance,
      lat,
      lng
    };
  }

  function googleEmbedUrl(d) {
    if (d && d.lat != null && d.lng != null && !Number.isNaN(d.lat) && !Number.isNaN(d.lng)) {
      return `https://www.google.com/maps?q=${encodeURIComponent(d.lat + "," + d.lng)}&z=15&output=embed`;
    }

    const q = d.fullAddress || d.name;
    return `https://www.google.com/maps?q=${encodeURIComponent(q)}&z=15&output=embed`;
  }

  function ensureMapConnectionHints() {
    if (document.head && !document.querySelector('link[data-collect-preconnect="maps-google"]')) {
      const link = document.createElement("link");
      link.rel = "preconnect";
      link.href = "https://www.google.com";
      link.setAttribute("crossorigin", "");
      link.setAttribute("data-collect-preconnect", "maps-google");
      document.head.appendChild(link);
    }

    if (document.head && !document.querySelector('link[data-collect-dns-prefetch="maps-google"]')) {
      const link = document.createElement("link");
      link.rel = "dns-prefetch";
      link.href = "//www.google.com";
      link.setAttribute("data-collect-dns-prefetch", "maps-google");
      document.head.appendChild(link);
    }
  }

  const mapLoadTimers = new WeakMap();

  function scheduleMapLoadForAccordion(acc, delayMs = 60) {
    if (!acc) return;

    const existingTimer = mapLoadTimers.get(acc);
    if (existingTimer) {
      clearTimeout(existingTimer);
    }

    const timer = setTimeout(() => {
      mapLoadTimers.delete(acc);
      if (!acc.open) return;
      loadMapForAccordion(acc);
    }, delayMs);

    mapLoadTimers.set(acc, timer);
  }

  function loadMapForAccordion(acc) {
    if (!acc) return;
    const iframe = acc.querySelector("[data-collect-map]");
    if (!iframe) return;

    const targetSrc = safe(iframe.getAttribute("data-collect-map-src"));
    if (!targetSrc) return;

    const currentSrc = safe(iframe.getAttribute("src"));
    if (currentSrc === targetSrc) return;

    iframe.setAttribute("src", targetSrc);
  }

  function unloadMapForAccordion(acc) {
    if (!acc) return;

    const existingTimer = mapLoadTimers.get(acc);
    if (existingTimer) {
      clearTimeout(existingTimer);
      mapLoadTimers.delete(acc);
    }

    const iframe = acc.querySelector("[data-collect-map]");
    if (!iframe) return;

    const currentSrc = safe(iframe.getAttribute("src"));
    if (!currentSrc || currentSrc === "about:blank") return;

    iframe.setAttribute("src", "about:blank");
  }

  function getSelectedDealer(root) {
    if (!root) return null;

    if (root._collectSelectedDealer) {
      return root._collectSelectedDealer;
    }

    const idx = getSelectedIndex(root);
    if (idx == null || !root._collectDealers) return null;

    return root._collectDealers[idx] || null;
  }

  function syncClickCollectAttributes(root) {
    if (!root) return;

    const dealer = getSelectedDealer(root);
    const enabled = !!(isClickAndCollectTabActive(root) && hasSelectedStore(root) && dealer);

    setOptionalHiddenValue(qs(root, "[data-collect-hidden-store-name]"), dealer && dealer.name, enabled);
    setOptionalHiddenValue(
      qs(root, "[data-collect-hidden-store-address]"),
      dealer && (dealer.fullAddress || dealer.addressForUI),
      enabled
    );
    setOptionalHiddenValue(qs(root, "[data-collect-hidden-store-id]"), dealer && dealer.storeCode, enabled);
    setOptionalHiddenValue(qs(root, "[data-collect-hidden-store-email]"), dealer && dealer.email, enabled);
    setOptionalHiddenValue(qs(root, "[data-collect-hidden-store-phone]"), dealer && dealer.phone, enabled);
    setHiddenInput(qs(root, "[data-collect-hidden-fulfilment-method]"), "Click and Collect", enabled);
    setHiddenInput(qs(root, "[data-collect-hidden-collection-store-id]"), dealer && dealer.storeCode, enabled);
    setHiddenInput(qs(root, "[data-collect-hidden-collection-store-name]"), dealer && dealer.name, enabled);
  }

  function getClickCollectAttributes(root) {
    const dealer = getSelectedDealer(root);
    if (!dealer || !isClickAndCollectTabActive(root) || !hasSelectedStore(root)) return null;

    return {
      collect_method: "click_collect",
      collect_store_name: safe(dealer.name),
      collect_store_address: safe(dealer.fullAddress || dealer.addressForUI),
      collect_store_code: safe(dealer.storeCode),
      collect_store_email: safe(dealer.email),
      collect_store_phone: safe(dealer.phone),
      commission_store_code: safe(dealer.storeCode),
      fulfilment_method: "Click and Collect",
      collection_store_id: safe(dealer.storeCode),
      collection_store_name: safe(dealer.name),
    };
  }

  function getHomeDeliveryAttributes() {
      const store = readCommissionStore();
      const commissionStoreCode = safe(store && store.code);
    return {
      collect_method: "home_delivery",
      collect_store_name: "",
      collect_store_address: "",
      collect_store_code: "",
      collect_store_email: "",
      collect_store_phone: "",
      commission_store_code: commissionStoreCode,
      fulfilment_method: "",
      collection_store_id: "",
      collection_store_name: "",
    };
  }

  function getCheckoutPath() {
    const routes = window.themeVariables && window.themeVariables.routes;
    const rootPrefix = safe(routes && routes.rootUrlWithoutSlash);
    return `${rootPrefix}/checkout`;
  }

  function getCheckoutAddress1(dealer) {
    const baseAddress = safe(dealer && (dealer.address1 || dealer.fullAddress || dealer.addressForUI));
    return [baseAddress, safe(dealer && dealer.address2)]
      .filter(Boolean)
      .join(", ");
  }

  function buildCheckoutPrefillUrl(root) {
    const dealer = getSelectedDealer(root);
    const url = new URL(getCheckoutPath(), window.location.origin);

    url.searchParams.set("step", "contact_information");
    url.searchParams.set("checkout[shipping_address][first_name]", "");
    url.searchParams.set("checkout[shipping_address][last_name]", "");
    url.searchParams.set(
      "checkout[shipping_address][company]",
      safe(dealer && dealer.name) ? `${safe(dealer && dealer.name)}, Click & Collect` : "Click & Collect"
    );
    url.searchParams.set(
      "checkout[shipping_address][address1]",
      getCheckoutAddress1(dealer)
    );
    url.searchParams.set("checkout[shipping_address][address2]", "");
    url.searchParams.set("checkout[shipping_address][city]", safe(dealer && dealer.city));
    url.searchParams.set("checkout[shipping_address][zip]", safe(dealer && dealer.postcode));
    url.searchParams.set(
      "checkout[shipping_address][country]",
      safe((dealer && dealer.country) || "United Kingdom")
    );
    url.searchParams.set("checkout[shipping_address][phone]", "");
    return url.toString();
  }

  function buildCheckoutClearUrl() {
    const url = new URL(getCheckoutPath(), window.location.origin);

    url.searchParams.set("step", "contact_information");
    setBlankCheckoutShippingParams(url);

    return url.toString();
  }

  function setBlankCheckoutShippingParams(url) {
    url.searchParams.set("checkout[shipping_address][first_name]", "");
    url.searchParams.set("checkout[shipping_address][last_name]", "");
    url.searchParams.set("checkout[shipping_address][company]", "");
    url.searchParams.set("checkout[shipping_address][address1]", "");
    url.searchParams.set("checkout[shipping_address][address2]", "");
    url.searchParams.set("checkout[shipping_address][city]", "");
    url.searchParams.set("checkout[shipping_address][zip]", "");
    url.searchParams.set("checkout[shipping_address][phone]", "");
  }

  function buildCartPermalinkCheckoutUrl(cart) {
    const items = cart && Array.isArray(cart.items) ? cart.items : [];
    const itemPath = items
      .filter(function (item) {
        return item && item.variant_id && item.quantity > 0;
      })
      .map(function (item) {
        return `${encodeURIComponent(item.variant_id)}:${encodeURIComponent(item.quantity)}`;
      })
      .join(",");

    if (!itemPath) return buildCheckoutClearUrl();

    const routes = window.themeVariables && window.themeVariables.routes;
    const rootPrefix = safe(routes && routes.rootUrlWithoutSlash);
    const url = new URL(`${rootPrefix}/cart/${itemPath}`, window.location.origin);

    url.searchParams.set("step", "contact_information");
    url.searchParams.set("attributes[collect_method]", "home_delivery");
    url.searchParams.set("attributes[commission_store_code]", commissionStoreCode);

    setBlankCheckoutShippingParams(url);

    return url.toString();
  }

  function fetchCartForCheckout() {
    const routes = window.themeVariables && window.themeVariables.routes;
    const cartUrl = safe(routes && routes.cartUrl) || "/cart";

    return fetch(`${cartUrl}.js`, {
      headers: { Accept: "application/json" },
      cache: "reload",
    }).then(function (response) {
      if (!response.ok) throw new Error("Could not load cart before checkout");
      return response.json();
    });
  }

  function submitClickCollectCheckout(root) {
    const checkoutUrl = buildCheckoutPrefillUrl(root);
    const attributes = getClickCollectAttributes(root);

    if (!attributes || root.__collectCheckoutSubmitting) {
      window.location.href = checkoutUrl;
      return;
    }

    root.__collectCheckoutSubmitting = true;
    setCheckoutDisabled(root, true);

    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ attributes }),
    })
      .catch(function (error) {
        console.warn("[collect-tabs] Could not save Click & Collect attributes before checkout:", error);
      })
      .finally(function () {
        window.location.href = checkoutUrl;
      });
  }

  function submitHomeDeliveryCheckout(root) {
    if (root.__homeDeliveryCheckoutSubmitting) {
      fetchCartForCheckout()
        .then(function (cart) {
          window.location.href = buildCartPermalinkCheckoutUrl(cart);
        })
        .catch(function () {
          window.location.href = buildCheckoutClearUrl();
        });
      return;
    }

    root.__homeDeliveryCheckoutSubmitting = true;
    setCheckoutDisabled(root, true);

    const clearAttributes = fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ attributes: getHomeDeliveryAttributes() }),
    }).catch(function (error) {
        console.warn("[collect-tabs] Could not clear Click & Collect attributes before checkout:", error);
      });

    clearAttributes
      .then(fetchCartForCheckout)
      .then(function (cart) {
        window.location.href = buildCartPermalinkCheckoutUrl(cart);
      })
      .catch(function () {
        window.location.href = buildCheckoutClearUrl();
      });
  }

  function setHidden(root, d, selected) {
    const method = qs(root, "[data-collect-hidden-method]");

    root._collectSelectedDealer = selected ? d : null;

    if (method) method.value = selected ? "click_collect" : "home_delivery";
    syncClickCollectAttributes(root);
  }

  function syncSelectedRowLayout(root) {
    qsa(root, "[data-collect-acc]").forEach((acc) => {
      const left = acc.querySelector("summary .left");
      const right = acc.querySelector("summary .right");
      const dist = acc.querySelector("summary .dist");
      if (!left || !right || !dist) return;

      const isSelected = acc.classList.contains("is-selected");

      if (isSelected) {
        if (dist.parentElement !== left) left.appendChild(dist);
      } else {
        if (dist.parentElement !== right) right.prepend(dist);
      }
    });
  }

  function syncSelectedButtonPlacement(root) {
    qsa(root, "[data-collect-acc]").forEach((acc) => {
      const summary = acc.querySelector("summary");
      const btn = acc.querySelector("[data-collect-select-btn]");
      if (!summary || !btn) return;

      if (btn.parentElement !== summary) {
        summary.appendChild(btn);
      }
    });
  }

  function resetSelection(root) {
    setSelectedIndex(root, null);
    setHidden(root, { name: "", fullAddress: "", addressForUI: "", storeCode: "", email: "", phone: "" }, false);

    qsa(root, "[data-collect-acc]").forEach((acc) => {
      acc.classList.remove("is-selected");
      if (acc.open) acc.open = false;
      unloadMapForAccordion(acc);
    });

    qsa(root, "[data-collect-select-btn]").forEach((b) => {
      b.textContent = "Select";
      b.classList.remove("is-selected");
    });

    syncSelectedRowLayout(root);
    syncSelectedButtonPlacement(root);
    syncCheckoutState(root);
  
  }

  function markSelectedUI(root, idx) {
    qsa(root, "[data-collect-acc]").forEach((acc) => acc.classList.remove("is-selected"));
    qsa(root, "[data-collect-select-btn]").forEach((b) => {
      b.textContent = "Select";
      b.classList.remove("is-selected");
    });

    const acc = qs(root, `[data-collect-acc][data-collect-index="${idx}"]`);
    if (acc) acc.classList.add("is-selected");

    const btn = qs(root, `[data-collect-acc][data-collect-index="${idx}"] [data-collect-select-btn]`);
    if (btn) {
      btn.textContent = "Selected";
      btn.classList.add("is-selected");
    }

    syncSelectedRowLayout(root);
    syncSelectedButtonPlacement(root);
  }

  function renderList(root, dealers) {
    const box = qs(root, "[data-collect-results]");
    if (!box) return;

    const limitAttrRaw = Number(root.getAttribute("data-collect-max-results"));
    const limit = Number.isFinite(limitAttrRaw) ? limitAttrRaw : 10;

    let ordered = dealers
      .map(normDealer)
      .sort(function (a, b) {
        const aMiles = getDistanceMilesForDealer(root, a);
        const bMiles = getDistanceMilesForDealer(root, b);

        if (aMiles == null && bMiles == null) return 0;
        if (aMiles == null) return 1;
        if (bMiles == null) return -1;

        return aMiles - bMiles;
      });

    if (limit > 0) {
      ordered = ordered.slice(0, limit);
    }

    root._collectDealers = ordered;

    box.innerHTML = ordered
      .map((d, i) => {
        const miles = getDistanceMilesForDealer(root, d);
        const dist = miles != null ? `${miles.toFixed(1)} Miles` : "";
        const mapUrl = googleEmbedUrl(d);
        const openingHoursHtml = renderOpeningHours(getDealerOpeningHours(d));

        return `
          <details class="collect-tabs__acc" data-collect-acc data-collect-index="${i}">
            <summary class="collect-tabs__row">
            <div class="content">
                <div class="left">
                  <span class="name">${d.name}</span>
                </div>
                <div class="right">
                  <span class="dist">${dist}</span>
                  <span class="commission-store__link collect-tabs__more-info">More info</span>
                </div>
              </div>
              <button type="button" class="collect-tabs__select-btn" data-collect-select-btn>
                Select
              </button>
            </summary>

            <div class="collect-tabs__detail">
              <div class="collect-tabs__map-wrap">
                <iframe
                  data-collect-map
                  data-collect-map-src="${mapUrl}"
                  class="collect-tabs__map"
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                  src="about:blank"
                  title="Map"
                ></iframe>
              </div>

              <div class="collect-tabs__detail-body">
                <div class="collect-tabs__detail-header"></div>

                <div class="collect-tabs__detail-meta text--xsmall">
                  <div><strong>Address:</strong> ${safe(d.addressForUI)}</div>
                  ${openingHoursHtml}
                </div>
              </div>
            </div>
          </details>
        `;
      })
      .join("");

    showUI(root, true);

    qsa(root, "[data-collect-acc][open]").forEach((acc) => {
      scheduleMapLoadForAccordion(acc);
    });

    syncSelectedRowLayout(root);
    syncSelectedButtonPlacement(root);

    if (isCommissionContext(root)) {
      setSelectedIndex(root, null);
    }
  }

  const controllers = new WeakMap();
  const lastQuery = new WeakMap();

  function abortInFlight(root) {
    const prev = controllers.get(root);
    if (prev) prev.abort();
  }

  async function doSearchByCoords(root, lat, lng, { force = false } = {}) {
    const apiBase = root.getAttribute("data-dealer-api");
    if (!apiBase) return;

    setSearchMode(root, "geo");
    setUserCoords(root, lat, lng);
    setInputCoords(root, lat, lng);

    const key = `__geo__${lat},${lng}`;
    const prevQ = lastQuery.get(root);
    if (!force && prevQ === key) return;
    lastQuery.set(root, key);

    abortInFlight(root);
    const controller = new AbortController();
    controllers.set(root, controller);

    setHint(root, "Searching nearby shops…");
    showUI(root, false);
    resetSelection(root);

    try {
      const dealersRaw = await fetchDealers(root, apiBase, lat, lng, controller.signal);
      if (!dealersRaw.length) {
        setHint(root, "No shops found within range.");
        showUI(root, false);
        syncCheckoutState(root);
        return;
      }

      setHint(root, "");
      renderList(root, dealersRaw);
    } catch (e) {
      if (e.name === "AbortError") return;
      console.warn("[collect-tabs] dealers error:", e);
      setHint(root, "Couldn’t load shops (check CORS / API availability).");
      showUI(root, false);
      syncCheckoutState(root);
    }
  }

  async function doSearch(root, query, { force = false } = {}) {
    const apiBase = root.getAttribute("data-dealer-api");
    if (!apiBase) return;

    const q = safe(query);

    setSearchMode(root, "manual");
    markInputAsScriptSet(root, false);

    if (q.length < 3) {
      setHint(root, "");
      showUI(root, false);
      resetSelection(root);
      return;
    }

    const prevQ = lastQuery.get(root);
    if (!force && prevQ === q) return;
    lastQuery.set(root, q);

    abortInFlight(root);
    const controller = new AbortController();
    controllers.set(root, controller);

    setHint(root, "Searching nearby shops…");
    showUI(root, false);
    resetSelection(root);

    try {
      const geo = await geocodeWithGoogle(root, q, controller.signal);

      if (!geo) {
        setHint(root, "No location found. Try a fuller postcode/address.");
        showUI(root, false);
        syncCheckoutState(root);
        return;
      }

      setUserCoords(root, geo.lat, geo.lng);

      const dealersRaw = await fetchDealers(root, apiBase, geo.lat, geo.lng, controller.signal);
      if (!dealersRaw.length) {
        setHint(root, "No shops found within range.");
        showUI(root, false);
        syncCheckoutState(root);
        return;
      }

      setHint(root, "");
      renderList(root, dealersRaw);
    } catch (e) {
      if (e.name === "AbortError") return;
      console.warn("[collect-tabs] search error:", e);
      setHint(root, "No location found. Try a fuller postcode/address.");
      showUI(root, false);
      syncCheckoutState(root);
    }
  }

  async function doGeoLocate(root) {
    if (!navigator.geolocation) {
      setHint(root, "Geolocation isn’t available on this device. Type your postcode instead.");
      return;
    }

    abortInFlight(root);
    setSearchMode(root, "geo");
    resetSelection(root);
    setHint(root, "Getting your location...");
    setInputValue(root, "Getting location...", { scriptSet: true });

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const lat = pos.coords.latitude;
        const lng = pos.coords.longitude;

        setInputCoords(root, lat, lng);
        doSearchByCoords(root, lat, lng, { force: true });
      },
      (err) => {
        console.warn("Geolocation error:", err);
        setHint(root, "Could not access your location. Please allow it or type your postcode.");
        clearInput(root, { clearHint: false, resetQuery: true });
        showUI(root, false);
      },
      { enableHighAccuracy: false, timeout: 12000, maximumAge: 60000 }
    );
  }

  const debouncedSearch = debounce((root, value) => doSearch(root, value, { force: false }), 450);

  document.addEventListener("input", function (e) {
    const input =
      e.target && e.target.matches && e.target.matches("[data-collect-search]") ? e.target : null;
    if (!input) return;

    const root = getRoot(input);
    if (!root) return;

    hideCheckoutWarnings(root);

    // Ignore synthetic input events triggered by script-driven UI refreshes
    // (for example after selecting a store).
    if (!e.isTrusted && isInputScriptSet(root)) {
      return;
    }

    setSearchMode(root, "manual");
    markInputAsScriptSet(root, false);
    root._collectLastSearchText = safe(input.value);

    if (isClickAndCollectTabActive(root)) {
      resetSelection(root);
      setCheckoutDisabled(root, true);
    }

    debouncedSearch(root, input.value);
  });

  document.addEventListener("focusin", function (e) {
    const input =
      e.target && e.target.matches && e.target.matches("[data-collect-search]") ? e.target : null;
    if (!input) return;

    const root = getRoot(input);
    if (!root) return;

    if (isProgrammaticInputFocus(input)) {
      return;
    }

    if (isInputScriptSet(root) && safe(input.value)) {
      clearInput(root, { clearHint: true, resetQuery: true });
    }
  });

  document.addEventListener("click", function (e) {

    const interactedWithCollectArea =
  e.target &&
  e.target.closest &&
  e.target.closest(
    "[data-home-commission-picker], [data-collect-search], [data-collect-geolocate], [data-collect-acc], [data-collect-select-btn], .collect-tabs__tab"
  );

if (interactedWithCollectArea) {
  const root = getRoot(interactedWithCollectArea);
  if (root) hideCheckoutWarnings(root);
}

    const commissionInfoLink =
      e.target && e.target.closest ? e.target.closest(".commission-store__link") : null;
    if (commissionInfoLink && safe(commissionInfoLink.getAttribute("href")) === "#") {
      e.preventDefault();
    }

    const commissionOpenTrigger =
      e.target && e.target.closest
        ? e.target.closest("[data-commission-card-open], [data-commission-change], [data-commission-card-chosen]")
        : null;

    if (commissionOpenTrigger) {
      const root = getRoot(commissionOpenTrigger);
      if (root) {
        e.preventDefault();
        openHomeCommissionPicker(root);
      }
      return;
    }

    const commissionPicker = e.target && e.target.closest ? e.target.closest("[data-home-commission-picker]") : null;
    if (commissionPicker) {
      const root = getRoot(commissionPicker);
      const clickedInsidePanel = e.target && e.target.closest ? e.target.closest("[data-commission-panel]") : null;
      const clickedClose = e.target && e.target.closest ? e.target.closest("[data-commission-panel-toggle]") : null;
      const clickedInfoLink = e.target && e.target.closest ? e.target.closest(".commission-store__link") : null;

      if (root && !isCommissionContext(root) && !clickedInsidePanel && !clickedClose && !clickedInfoLink) {
        e.preventDefault();
        openHomeCommissionPicker(root);
        return;
      }
    }

    const commissionCloseTrigger =
      e.target && e.target.closest ? e.target.closest("[data-commission-panel-toggle]") : null;

    if (commissionCloseTrigger) {
      const root = getRoot(commissionCloseTrigger);
      if (root) {
        e.preventDefault();
        closeHomeCommissionPicker(root);
      }
      return;
    }

    const input =
      e.target && e.target.matches && e.target.matches("[data-collect-search]") ? e.target : null;

    if (input) {
      const root = getRoot(input);
      if (!root) return;

      if (isInputScriptSet(root) && safe(input.value)) {
        clearInput(root, { clearHint: true, resetQuery: true });
      }
      return;
    }

    const geoBtn = e.target && e.target.closest ? e.target.closest("[data-collect-geolocate]") : null;
    if (geoBtn) {
      const root = getRoot(geoBtn);
      if (!root) return;
      doGeoLocate(root);
      return;
    }

    const summary =
      e.target && e.target.closest ? e.target.closest("[data-collect-acc] > summary") : null;

    if (summary) {
      const acc = summary.parentElement;
      const root = getRoot(acc);
      if (!root) return;

      requestAnimationFrame(() => {
        root.querySelectorAll("[data-collect-acc]").forEach((other) => {
          if (other === acc) return;
          if (other.open) other.open = false;
          unloadMapForAccordion(other);
        });

        if (acc.open) {
          scheduleMapLoadForAccordion(acc);
        } else {
          unloadMapForAccordion(acc);
        }
      });
    }

    const selectBtn =
      e.target && e.target.closest ? e.target.closest("[data-collect-select-btn]") : null;

    if (selectBtn) {
      const root = getRoot(selectBtn);
      if (!root) return;

      const acc = selectBtn.closest("[data-collect-acc]");
      const idx = acc ? Number(acc.getAttribute("data-collect-index")) : NaN;
      const d = root._collectDealers && Number.isFinite(idx) ? root._collectDealers[idx] : null;
      if (!d) return;

      const currentlySelectedIdx = getSelectedIndex(root);

      if (selectBtn.classList.contains("is-selected") && currentlySelectedIdx === idx) {
        resetSelection(root);
        clearInput(root, { clearHint: true, resetQuery: true });
        return;
      }

      setHidden(root, d, true);
      setSelectedIndex(root, idx);
      markSelectedUI(root, idx);
      syncCheckoutState(root);

      if (isCommissionContext(root)) {
        const selectedStore = {
          name: safe(d.name),
          code: safe(d.storeCode),
        };
        writeCommissionStore(selectedStore);
        root.dispatchEvent(new CustomEvent("map:commission-store-selected", {
          bubbles: true,
          detail: selectedStore,
        }));

        const parentCollectRoot = root.parentElement
          ? root.parentElement.closest("[data-collect-tabs]")
          : null;

        if (parentCollectRoot && parentCollectRoot !== root && !isCommissionContext(parentCollectRoot)) {
          closeHomeCommissionPicker(parentCollectRoot);
        }
      }

      clearInput(root, { clearHint: true, resetQuery: true, scriptSet: true });
      return;
    }
  });

  document.addEventListener("change", function (e) {
    const radio =
      e.target && e.target.matches && e.target.matches('input[type="radio"][id^="collect_tab_"]')
        ? e.target
        : null;
    if (!radio) return;

    const root = getRoot(radio);
    if (!root) return;

    syncCheckoutState(root);
  });

  document.addEventListener("submit", function (e) {
    const form = e.target instanceof HTMLFormElement ? e.target : null;
    if (!form) return;
    let handled = false;

    qsa(document, "[data-collect-tabs]").forEach(function (root) {
      if (handled) return;
      if (isCommissionContext(root)) return;

      const methodInput = qs(root, "[data-collect-hidden-method]");
      if (!methodInput) return;

      const explicitFormId = safe(methodInput.getAttribute("form"));
      const belongsToForm =
        (explicitFormId && form.id === explicitFormId) ||
        methodInput.form === form ||
        root.closest("form") === form;

      if (belongsToForm) {
        syncCheckoutState(root);
        if (isClickAndCollectTabActive(root) && hasSelectedStore(root) && getSelectedDealer(root)) {
          handled = true;
          e.preventDefault();
          submitClickCollectCheckout(root);
        } else if (isHomeTabActive(root)) {
          handled = true;
          e.preventDefault();
          submitHomeDeliveryCheckout(root);
        }
      }
    });
  }, true);

  document.addEventListener("keydown", function (e) {
    const card =
      e.target &&
      e.target.matches &&
      (e.target.matches("[data-commission-card-open]") ||
        e.target.matches("[data-commission-card-chosen]"))
        ? e.target
        : null;
    if (!card) return;

    if (e.key !== "Enter" && e.key !== " ") return;
    e.preventDefault();

    const root = getRoot(card);
    if (!root) return;
    openHomeCommissionPicker(root);
  });

  function hydrateRoot(root) {
    if (!root) return;

    if (!root.__collectTabsBootstrapped) {
      setSearchMode(root, "manual");
      markInputAsScriptSet(root, false);
      root.__collectTabsBootstrapped = true;
      ensureMapConnectionHints();
    }

    if (isCommissionContext(root) && root.dataset.collectAutoLoaded !== "1") {
      const autoLoad = safe(root.getAttribute("data-collect-auto-load")).toLowerCase();
      const apiBase = safe(root.getAttribute("data-dealer-api"));

      if (autoLoad === "all" && apiBase) {
        root.dataset.collectAutoLoaded = "1";
        setHint(root, "Loading shops...");
        showUI(root, false);

        fetchDealers(root, apiBase, null, null)
          .then((dealersRaw) => {
            if (!Array.isArray(dealersRaw) || !dealersRaw.length) {
              return fetchDealers(root, apiBase, 54.5, -2, null);
            }

            return dealersRaw;
          })
          .then((dealersRaw) => {
            if (!Array.isArray(dealersRaw) || !dealersRaw.length) {
              setHint(root, "No shops found.");
              showUI(root, false);
              return;
            }

            setHint(root, "");
            renderList(root, dealersRaw);
          })
          .catch((error) => {
            console.warn("[collect-tabs] initial dealer load error:", error);
            setHint(root, "Couldn’t load shops (check CORS / API availability).");
            showUI(root, false);
          });
      }
    }

    if (!isCommissionContext(root)) {
      clearLegacyCommissionAttributesOnce();
    }

    bindHomeCommissionPickerInteractions(root);

    syncCheckoutState(root);
    syncSelectedRowLayout(root);
    syncSelectedButtonPlacement(root);
    syncCommissionStoreUI(root);
  }

  function hydrateAllRoots() {
    qsa(document, "[data-collect-tabs]").forEach(hydrateRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", hydrateAllRoots);
  } else {
    hydrateAllRoots();
  }

  const domObserver = new MutationObserver((mutations) => {
    let shouldHydrate = false;

    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches("[data-collect-tabs]") || node.querySelector("[data-collect-tabs]")) {
          shouldHydrate = true;
          break;
        }
      }
      if (shouldHydrate) break;
    }

    if (shouldHydrate) hydrateAllRoots();
  });

  const observeTarget = document.documentElement || document.body;
  if (observeTarget) {
    domObserver.observe(observeTarget, { childList: true, subtree: true });
  }

  window.addEventListener("storage", function (event) {
    if (event && event.key && event.key !== COMMISSION_STORE_KEY) return;
    hydrateAllRoots();
  });

  window.addEventListener("map:commission-store-updated", function () {
    hydrateAllRoots();
  });
})();
